import { EventInput } from "@fullcalendar/common"
import { CustomerList } from "types/customer"
import { Products } from "types/e-commerce"
import { InvoiceList } from "types/invoice"
import { KeyedObject } from "types/root"
import { UserProfile } from "types/user-profile"

export const PRODUCT_LIST: Products[] = [
    {
      "id": 5,
      "image": "prod-5.png",
      "name": "Canon EOS 1500D 24.1 Digital SLR",
      "brand": "Canon",
      "offer": "30%",
      "description": "SLR Camera (Black) with EF S18-55...",
      "about": "Image Enlargement: After shooting, you can enlarge photographs of the objects for clear zoomed view. Change In Aspect Ratio: Boldly crop the subject and save it with a composition that has impact. You can convert it to a 1:1 square format, and after shooting you can create a photo that will be popular on SNS.",
      "quantity": 50,
      "rating": 3.5,
      "discount": 15,
      "salePrice": 15.99,
      "offerPrice": 12.99,
      "gender": "male",
      "categories": [
        "electronics",
        "camera"
      ],
      "colors": [
        "warningMain",
        "primary200"
      ],
      "popularity": 8392334687338496,
      "date": 8754233278988288,
      "created": new Date("2026-02-01T06:19:49.831Z"),
      "isStock": true,
      "new": 25
    },
    {
      "id": 7,
      "image": "prod-7.png",
      "name": "Apple MacBook Pro with Iphone",
      "brand": "Apple",
      "description": "11th Generation Intel® Core™ i5-11320H ...",
      "about": "Great choice for those who love poweful and fast laptopts. It comes with 2TB of harddrive and 12GB of RAM.Its fast and comes with a powerful processor",
      "quantity": 70,
      "rating": 4,
      "discount": 16,
      "offerPrice": 14.59,
      "gender": "male",
      "categories": [
        "electronics",
        "laptop"
      ],
      "colors": [
        "errorDark",
        "secondaryMain",
        "errorMain"
      ],
      "popularity": 7114430013767680,
      "date": 8695272389476352,
      "created": new Date("2026-02-17T17:59:49.831Z"),
      "isStock": true,
      "new": 30
    },
    {
      "id": 4,
      "image": "prod-4.png",
      "name": "Luxury Watches Centrix Gold",
      "brand": "Centrix",
      "offer": "20%",
      "description": "7655 Couple (Refurbished)...",
      "about": "This product from Centrix is a classic choice who love classical products. It it made of pure gold and weighs around 50 grams",
      "quantity": 3,
      "rating": 4,
      "discount": 20,
      "salePrice": 36,
      "offerPrice": 29.99,
      "gender": "kids",
      "categories": [
        "fashion",
        "watch"
      ],
      "colors": [
        "errorLight",
        "warningMain"
      ],
      "popularity": 5534360449056768,
      "date": 400059894071296,
      "created": new Date("2026-01-27T09:19:49.831Z"),
      "isStock": true,
      "new": 15
    },
    {
      "id": 3,
      "image": "prod-3.png",
      "name": "Fitbit MX30 Smart Watch",
      "brand": "Fitbit",
      "offer": "30%",
      "description": "(MX30- waterproof) watch",
      "about": "Fitbit is well known for making amazing smartwatches and this product is one of them, it is waterproof and battery power can last upto 2 days. Great product for smartwatch lovers",
      "quantity": 70,
      "rating": 4.5,
      "discount": 40,
      "salePrice": 85,
      "offerPrice": 49.9,
      "gender": "male",
      "categories": [
        "fashion",
        "watch"
      ],
      "colors": [
        "primary200",
        "primaryDark"
      ],
      "popularity": 1709170627706880,
      "date": 7994699149213696,
      "created": new Date("2026-01-30T06:14:49.831Z"),
      "isStock": true,
      "new": 35
    },
    {
      "id": 2,
      "image": "prod-2.png",
      "name": "Boat On-Ear Wireless ",
      "brand": "Boat",
      "description": "Mic(Bluetooth 4.2, Rockerz 450R...",
      "about": "Boat On-ear wireless headphones comes with bluethooth technology, comes with better sound quality and weighs around 200gm which seems very light when using ",
      "quantity": 45,
      "rating": 3.5,
      "discount": 10,
      "offerPrice": 81.99,
      "gender": "kids",
      "categories": [
        "electronics",
        "headphones"
      ],
      "colors": [
        "primary200",
        "successLight",
        "secondary200",
        "warningMain"
      ],
      "popularity": 4796035073310720,
      "date": 6620558250737664,
      "created": new Date("2026-01-24T06:55:49.831Z"),
      "isStock": false,
      "new": 40
    },
    {
      "id": 6,
      "image": "prod-6.png",
      "name": "Apple iPhone 13 Mini ",
      "brand": "Apple",
      "offer": "70%",
      "description": "13 cm (5.4-inch) Super",
      "about": "It fits for those who love photography since it has 48MP camera which shoots great photos even in low light. Also it has 8GB of RAm and 4000MAH battery which can last upto 12 hours a day ",
      "quantity": 40,
      "rating": 4.5,
      "discount": 10,
      "offerPrice": 86.99,
      "gender": "female",
      "categories": [
        "electronics",
        "iphone"
      ],
      "colors": [
        "primaryDark"
      ],
      "popularity": 6012995144515584,
      "date": 697830855409664,
      "created": new Date("2026-02-10T02:04:49.831Z"),
      "isStock": true,
      "new": 15
    },
    {
      "id": 8,
      "image": "prod-8.png",
      "name": "Apple iPhone 13 Pro",
      "brand": "Apple",
      "description": "(512GB ROM, MLLH3HN/A,..",
      "about": "The smartphone comes with 12GB of RAM and 2Ghz of processor.There are two front cameras, one of 20MP and second of 10MP for depth phptpgraphy.Its lightweight and fast",
      "quantity": 21,
      "rating": 4.5,
      "discount": 30,
      "salePrice": 129.99,
      "offerPrice": 100,
      "gender": "female",
      "categories": [
        "electronics",
        "iphone"
      ],
      "colors": [
        "errorMain",
        "successDark"
      ],
      "popularity": 3947419872002048,
      "date": 6902046867324928,
      "created": new Date("2026-02-03T04:54:49.831Z"),
      "isStock": true,
      "new": 20
    },
    {
      "id": 1,
      "image": "prod-1.png",
      "name": "Apple Series 4 GPS A38 MM Space",
      "brand": "Apple",
      "description": "Apple Watch SE Smartwatch ",
      "about": "This watch from Apple is highly known for its features, like you can control your apple smartphone with this watch and you can do everything you would want to do on smartphone",
      "quantity": 3,
      "rating": 4,
      "discount": 75,
      "offerPrice": 275,
      "gender": "male",
      "categories": [
        "fashion",
        "watch"
      ],
      "colors": [
        "errorDark",
        "errorMain",
        "secondaryMain"
      ],
      "popularity": 5750882050244608,
      "date": 7627313141252096,
      "created": new Date("2026-01-26T09:44:49.831Z"),
      "isStock": true,
      "new": 45
    },
    {
      "id": 9,
      "image": "prod-9.png",
      "name": "Canon EOS 1500D 24.1 Digital",
      "brand": "Kotak",
      "description": "(512GB ROM, MLLH3HN/A,..",
      "about": "Image Enlargement: After shooting, you can enlarge photographs of the objects for clear zoomed view. Change In Aspect Ratio: Boldly crop the subject and save it with a composition that has impact. You can convert it to a 1:1 square format, and after shooting you can create a photo that will be popular on SNS.",
      "quantity": 21,
      "rating": 4,
      "discount": 5,
      "offerPrice": 399,
      "gender": "female",
      "categories": [
        "electronics",
        "camera"
      ],
      "colors": [
        "errorMain",
        "successDark"
      ],
      "popularity": 8721106934431744,
      "date": 2644843178229760,
      "created": new Date("2026-02-03T04:54:49.831Z"),
      "isStock": true,
      "new": 10
    }
]

export const PRODUCT_DETAILS: KeyedObject = {
    1: {
        "id": 1,
        "image": "prod-1.png",
        "name": "Apple Series 4 GPS A38 MM Space",
        "brand": "Apple",
        "description": "Apple Watch SE Smartwatch ",
        "about": "This watch from Apple is highly known for its features, like you can control your apple smartphone with this watch and you can do everything you would want to do on smartphone",
        "quantity": 3,
        "rating": 4,
        "discount": 75,
        "offerPrice": 275,
        "gender": "male",
        "categories": [
            "fashion",
            "watch"
        ],
        "colors": [
            "errorDark",
            "errorMain",
            "secondaryMain"
        ],
        "popularity": 747809217183744,
        "date": 3947879070695424,
        "created": "2026-01-26T10:45:10.332Z",
        "isStock": true,
        "new": 45
    },
    2: {
        "id": 2,
        "image": "prod-2.png",
        "name": "Boat On-Ear Wireless ",
        "brand": "Boat",
        "description": "Mic(Bluetooth 4.2, Rockerz 450R...",
        "about": "Boat On-ear wireless headphones comes with bluethooth technology, comes with better sound quality and weighs around 200gm which seems very light when using ",
        "quantity": 45,
        "rating": 3.5,
        "discount": 10,
        "offerPrice": 81.99,
        "gender": "kids",
        "categories": [
            "electronics",
            "headphones"
        ],
        "colors": [
            "primary200",
            "successLight",
            "secondary200",
            "warningMain"
        ],
        "popularity": 7227164302770176,
        "date": 4362544927997952,
        "created": "2026-01-24T07:56:10.332Z",
        "isStock": false,
        "new": 40
    },
    3: {
        "id": 3,
        "image": "prod-3.png",
        "name": "Fitbit MX30 Smart Watch",
        "brand": "Fitbit",
        "offer": "30%",
        "description": "(MX30- waterproof) watch",
        "about": "Fitbit is well known for making amazing smartwatches and this product is one of them, it is waterproof and battery power can last upto 2 days. Great product for smartwatch lovers",
        "quantity": 70,
        "rating": 4.5,
        "discount": 40,
        "salePrice": 85,
        "offerPrice": 49.9,
        "gender": "male",
        "categories": [
            "fashion",
            "watch"
        ],
        "colors": [
            "primary200",
            "primaryDark"
        ],
        "popularity": 3822864455172096,
        "date": 7590921080143872,
        "created": "2026-01-30T07:15:10.340Z",
        "isStock": true,
        "new": 35
    },
    4: {
        "id": 4,
        "image": "prod-4.png",
        "name": "Luxury Watches Centrix Gold",
        "brand": "Centrix",
        "offer": "20%",
        "description": "7655 Couple (Refurbished)...",
        "about": "This product from Centrix is a classic choice who love classical products. It it made of pure gold and weighs around 50 grams",
        "quantity": 3,
        "rating": 4,
        "discount": 20,
        "salePrice": 36,
        "offerPrice": 29.99,
        "gender": "kids",
        "categories": [
            "fashion",
            "watch"
        ],
        "colors": [
            "errorLight",
            "warningMain"
        ],
        "popularity": 3767595805179904,
        "date": 7816380602646528,
        "created": "2026-01-27T10:20:10.340Z",
        "isStock": true,
        "new": 15
    },
    5: {
        "id": 5,
        "image": "prod-5.png",
        "name": "Canon EOS 1500D 24.1 Digital SLR",
        "brand": "Canon",
        "offer": "30%",
        "description": "SLR Camera (Black) with EF S18-55...",
        "about": "Image Enlargement: After shooting, you can enlarge photographs of the objects for clear zoomed view. Change In Aspect Ratio: Boldly crop the subject and save it with a composition that has impact. You can convert it to a 1:1 square format, and after shooting you can create a photo that will be popular on SNS.",
        "quantity": 50,
        "rating": 3.5,
        "discount": 15,
        "salePrice": 15.99,
        "offerPrice": 12.99,
        "gender": "male",
        "categories": [
            "electronics",
            "camera"
        ],
        "colors": [
            "warningMain",
            "primary200"
        ],
        "popularity": 5360820756152320,
        "date": 5709061672665088,
        "created": "2026-02-01T07:20:10.340Z",
        "isStock": true,
        "new": 25
    },
    6: {
        "id": 6,
        "image": "prod-6.png",
        "name": "Apple iPhone 13 Mini ",
        "brand": "Apple",
        "offer": "70%",
        "description": "13 cm (5.4-inch) Super",
        "about": "It fits for those who love photography since it has 48MP camera which shoots great photos even in low light. Also it has 8GB of RAm and 4000MAH battery which can last upto 12 hours a day ",
        "quantity": 40,
        "rating": 4.5,
        "discount": 10,
        "offerPrice": 86.99,
        "gender": "female",
        "categories": [
            "electronics",
            "iphone"
        ],
        "colors": [
            "primaryDark"
        ],
        "popularity": 8961462823288832,
        "date": 3739365815615488,
        "created": "2026-02-10T03:05:10.340Z",
        "isStock": true,
        "new": 15
    },
    7: {
        "id": 7,
        "image": "prod-7.png",
        "name": "Apple MacBook Pro with Iphone",
        "brand": "Apple",
        "description": "11th Generation Intel\u00ae Core\u2122 i5-11320H ...",
        "about": "Great choice for those who love poweful and fast laptopts. It comes with 2TB of harddrive and 12GB of RAM.Its fast and comes with a powerful processor",
        "quantity": 70,
        "rating": 4,
        "discount": 16,
        "offerPrice": 14.59,
        "gender": "male",
        "categories": [
            "electronics",
            "laptop"
        ],
        "colors": [
            "errorDark",
            "secondaryMain",
            "errorMain"
        ],
        "popularity": 3334870052896768,
        "date": 2440486931398656,
        "created": "2026-02-17T19:00:10.340Z",
        "isStock": true,
        "new": 30
    },
    8: {
        "id": 8,
        "image": "prod-8.png",
        "name": "Apple iPhone 13 Pro",
        "brand": "Apple",
        "description": "(512GB ROM, MLLH3HN/A,..",
        "about": "The smartphone comes with 12GB of RAM and 2Ghz of processor.There are two front cameras, one of 20MP and second of 10MP for depth phptpgraphy.Its lightweight and fast",
        "quantity": 21,
        "rating": 4.5,
        "discount": 30,
        "salePrice": 129.99,
        "offerPrice": 100,
        "gender": "female",
        "categories": [
            "electronics",
            "iphone"
        ],
        "colors": [
            "errorMain",
            "successDark"
        ],
        "popularity": 2583782745964544,
        "date": 6305285022941184,
        "created": "2026-02-03T05:55:10.340Z",
        "isStock": true,
        "new": 20
    },
    9: {
        "id": 9,
        "image": "prod-9.png",
        "name": "Canon EOS 1500D 24.1 Digital",
        "brand": "Kotak",
        "description": "(512GB ROM, MLLH3HN/A,..",
        "about": "Image Enlargement: After shooting, you can enlarge photographs of the objects for clear zoomed view. Change In Aspect Ratio: Boldly crop the subject and save it with a composition that has impact. You can convert it to a 1:1 square format, and after shooting you can create a photo that will be popular on SNS.",
        "quantity": 21,
        "rating": 4,
        "discount": 5,
        "offerPrice": 399,
        "gender": "female",
        "categories": [
            "electronics",
            "camera"
        ],
        "colors": [
            "errorMain",
            "successDark"
        ],
        "popularity": 6548318236704768,
        "date": 5487884157059072,
        "created": "2026-02-03T05:55:10.340Z",
        "isStock": true,
        "new": 10
    }
}

export const PRODUCT_REVIEW_LIST = [
    {
        "date": "2026-02-03T15:30:01.215Z",
        "id": "1",
        "profile": {
            "avatar": "avatar-1.png",
            "name": "Linnie Wagner",
            "status": true
        },
        "rating": 1.4347,
        "review": "Hu fip hidgep ban ga tez zofe hus niche figfetugi faj jeb irlibzu vit anozim. Bubjut mo ade beidrob owewi pippehsuw gor ib ud koevuwof widfedo sazovaoja gewriwid doghuj zouv voztiv."
    },
    {
        "date": "2026-01-29T04:20:01.215Z",
        "id": "2",
        "profile": {
            "avatar": "avatar-2.png",
            "name": "Russell Osborne",
            "status": true
        },
        "rating": 2.3151,
        "review": "Noj javnizkuf cej tiijaje namaje kehuifa hactipje zafjeh miruhude we sat lito padzal nuresjij awu lipbavos no. Ni ligusajon epu puphacpo hobvim difudij tumoho sazojobop rocdi nuek cakapra nina gotuzad fallep."
    },
    {
        "date": "2026-01-26T10:55:01.216Z",
        "id": "3",
        "profile": {
            "avatar": "avatar-3.png",
            "name": "Brian Vega",
            "status": false
        },
        "rating": 0.7324,
        "review": "Hiklicfi liguwop lu hunnawu hiw ha ci liza amihipim porzar olifi tuumudav cidvem. Fuwuhupa ba defnevku ukca gudec abuce ukuemi wevu kice sovcahcuw ja dis."
    }    
]

export const ADDRESS_LIST =  [
    {
        "building": "1654 Zideh Plz",
        "city": "Suwecpimmmmmm",
        "country": "kGambia",
        "destination": "office",
        "id": 1,
        "isDefault": false,
        "name": "Martin Shaw",
        "phone": "(939) 513-8172",
        "post": "HS6N 5ATkkk",
        "state": "Kentucky",
        "street": "27 Elabe Trailllllll"
    },
    {
        "building": "1359 Pusuw Park",
        "city": "Pazworog",
        "country": "Bahrain",
        "destination": "home",
        "id": 2,
        "isDefault": false,
        "name": "Billy Castillo",
        "phone": "(440) 597-4681",
        "post": "FK6T 8HK",
        "state": "Kentucky",
        "street": "1057 Geptoc Key"
    },
    {
        "building": "1654 Zideh Plz",
        "city": "Knoxville",
        "country": "United States",
        "destination": "office",
        "id": "d596332b-318e-42e4-b984-12e6ff0e77e3",
        "isDefault": false,
        "name": "Brenda Murphy",
        "phone": "8998877",
        "post": "778",
        "state": "Knoxville",
        "street": "125 Test Rd"
    }
]

export const CALENDAR_EVENT_LIST: EventInput[] =  [
    {
        "allDay": false,
        "color": "#f5222d",
        "description": "SCRUM Planning",
        "end": "2026-01-22T14:44:52.432Z",
        "id": "5e8882f1f0c9216397e05a9b",
        "start": "2026-01-22T12:29:52.432Z",
        "title": "Repeating Event"
    },
    {
        "allDay": true,
        "color": "#faad14",
        "description": "Sorry, John!",
        "end": "2026-01-26T17:44:52.432Z",
        "id": "5e8882fcd525e076b3c1542c",
        "start": "2026-01-26T17:29:52.432Z",
        "title": "Conference"
    },
    {
        "allDay": true,
        "color": "#52c41a",
        "description": "Inform about new contract",
        "end": "2026-01-30T18:14:52.432Z",
        "id": "5e8882e440f6322fa399eeb8",
        "start": "2026-01-31T18:14:52.432Z",
        "title": "All Day Event"
    },
    {
        "allDay": false,
        "color": "#f6ffed",
        "description": "Sorry, Stebin Ben!",
        "end": "2026-02-01T16:44:52.432Z",
        "id": "5e8882fcd525e076b3c1542d",
        "start": "2026-02-01T13:14:52.432Z",
        "textColor": "#52c41a",
        "title": "Opening Ceremony"
    },
    {
        "allDay": true,
        "color": "#8c8c8c",
        "description": "Discuss about new partnership",
        "end": "2026-02-01T17:14:52.432Z",
        "id": "5e8882eb5f8ec686220ff138",
        "start": "2026-01-30T18:14:52.432Z",
        "title": "Long Event"
    },
    {
        "allDay": false,
        "description": "Get a new quote for the payment processor",
        "end": "2026-02-03T08:30:52.432Z",
        "id": "5e88830672d089c53c46ece3",
        "start": "2026-02-03T06:30:52.432Z",
        "title": "Breakfast"
    },
    {
        "allDay": false,
        "color": "#fffbe6",
        "description": "Discuss about the new project",
        "end": "2026-02-03T15:30:52.432Z",
        "id": "5e888302e62149e4b49aa609",
        "start": "2026-02-03T09:45:52.432Z",
        "textColor": "#faad14",
        "title": "Meeting"
    },
    {
        "allDay": false,
        "color": "#f5222d",
        "description": "Let's Go",
        "end": "2026-02-03T11:30:52.432Z",
        "id": "5e888302e62149e4b49aa709",
        "start": "2026-02-03T09:00:52.432Z",
        "title": "Anniversary Celebration"
    },
    {
        "allDay": false,
        "description": "Discuss about the new project",
        "end": "2026-02-05T00:09:52.432Z",
        "id": "5e888302e69651e4b49aa609",
        "start": "2026-02-04T23:39:52.432Z",
        "title": "Send Gift"
    },
    {
        "allDay": false,
        "color": "#faad14",
        "description": "Let's Go",
        "end": "2026-02-04T23:29:52.432Z",
        "id": "5e8883062k8149e4b49aa709",
        "start": "2026-02-04T21:59:52.432Z",
        "title": "Birthday Party"
    },
    {
        "allDay": false,
        "color": "#8c8c8c",
        "description": "SCRUM Planning",
        "end": "2026-02-04T22:44:52.432Z",
        "id": "5e8882f1f0c9216396e05a9b",
        "start": "2026-02-04T21:44:52.432Z",
        "title": "Repeating Event"
    },
    {
        "allDay": false,
        "color": "#f5222d",
        "description": "Let's Go",
        "end": "2026-02-04T23:04:52.432Z",
        "id": "5e888302e62149e4b49aa610",
        "start": "2026-02-04T21:59:52.432Z",
        "title": "Dinner"
    },
    {
        "allDay": true,
        "description": "Discuss about new partnership",
        "end": "2026-02-11T19:14:52.432Z",
        "id": "5e8882eb5f8ec686220ff131",
        "start": "2026-02-08T18:14:52.432Z",
        "title": "Long Event"
    },
    {
        "allDay": false,
        "color": "#1890ff",
        "description": "Discuss about the project launch",
        "end": "2026-02-09T18:34:52.433Z",
        "id": "5e888302e62349e4b49aa609",
        "start": "2026-02-09T18:29:52.433Z",
        "textColor": "#e6f7ff",
        "title": "Meeting"
    },
    {
        "allDay": false,
        "color": "#52c41a",
        "description": "Discuss about the tour",
        "end": "2026-02-15T23:04:52.433Z",
        "id": "5e888302e62149e4b49ab609",
        "start": "2026-02-15T21:59:52.433Z",
        "title": "Happy Hour"
    }
]

export const USERS: KeyedObject[] =  [
    {
        "avatar": "avatar-1.png",
        "birthdayText": "happy Birthday Alene",
        "company": "ABC Pvt Ltd",
        "id": 1,
        "isFavorite": true,
        "lastMessage": "11:30 AM",
        "latestMessage": {
            "message": "Yes, I saw it. Working on a fix now. Should be done by EOD.",
            "seen": false,
            "time": "3:12 PM"
        },
        "location": "Port Narcos",
        "name": "Alene",
        "online_status": "available",
        "personal_email": "alene@company.com",
        "personal_phone": "380-293-0177",
        "role": "Sr. Customer Manager",
        "status": "Technical Department",
        "unReadChatCount": 2,
        "work_email": "alene_work@company.com",
        "work_phone": "380-293-0177"
    },
    {
        "avatar": "avatar-2.png",
        "birthdayText": "happy Birthday Keefe",
        "company": "ABC Pvt Ltd",
        "id": 2,
        "isFavorite": false,
        "lastMessage": "10:16 AM",
        "latestMessage": {
            "message": "Agreed! Next time, let's try sushi.",
            "seen": true,
            "time": "1:31 PM"
        },
        "location": "Afghanistan",
        "name": "Keefe",
        "online_status": "available",
        "personal_email": "keefe@gmil.com",
        "personal_phone": "253-418-5940",
        "role": "Dynamic Operations Officer",
        "status": "Support Executive",
        "unReadChatCount": 3,
        "work_email": "keefe_work@gmil.com",
        "work_phone": "253-418-5940"
    },
    {
        "avatar": "avatar-3.png",
        "birthdayText": "happy Birthday Lazaro",
        "company": "ABC Pvt Ltd",
        "id": 3,
        "isFavorite": false,
        "lastMessage": "9:00 AM",
        "latestMessage": {
            "message": "Just uploaded them to the shared drive. Let me know if you need anything else!",
            "seen": false,
            "time": "10:16 AM"
        },
        "location": "Albania",
        "name": "Lazaro",
        "online_status": "available",
        "personal_email": "lazaro@gmil.com",
        "personal_phone": "283-029-1364",
        "role": "Resource Investigator",
        "status": "Resource Investigator",
        "unReadChatCount": 1,
        "work_email": "lazaro_work@gmil.com",
        "work_phone": "283-029-1364"
    },
    {
        "avatar": "avatar-4.png",
        "birthdayText": "happy Birthday Hazle",
        "company": "ABC Pvt Ltd",
        "id": 4,
        "isFavorite": false,
        "lastMessage": "08:36 AM",
        "latestMessage": {
            "message": "Thanks! Let me know if you spot any issues.",
            "seen": false,
            "time": "5:06 PM"
        },
        "location": "Algeria",
        "name": "Hazle",
        "online_status": "do_not_disturb",
        "personal_email": "hazle@gmil.com",
        "personal_phone": "380-293-0177",
        "role": "Teamworker",
        "status": "Teamworker",
        "unReadChatCount": 0,
        "work_email": "hazle_work@gmil.com",
        "work_phone": "380-293-0177"
    },
    {
        "avatar": "group-backend.png",
        "id": 15,
        "isFavorite": true,
        "isGroup": true,
        "lastMessage": "Yesterday",
        "latestMessage": {
            "message": "Database migration scheduled for tonight.",
            "seen": false,
            "time": "Yesterday"
        },
        "members": [
            "Agilulf Fuxg",
            "Adaline Bergfalks",
            "Eadwulf Beckete",
            "Midas"
        ],
        "name": "Backend Squad",
        "online_status": "active",
        "status": "API & Database",
        "unReadChatCount": 1
    },
    {
        "avatar": "avatar-5.png",
        "birthdayText": "happy Birthday Herman",
        "company": "ABC Pvt Ltd",
        "id": 5,
        "isFavorite": true,
        "lastMessage": "Yesterday",
        "latestMessage": {
            "message": "Thanks for the heads up! I'll prepare the slides tonight.",
            "seen": true,
            "time": "4:01 PM"
        },
        "location": "Andorra",
        "name": "Herman Essertg",
        "online_status": "do_not_disturb",
        "personal_email": "herman_essertg@gmil.com",
        "personal_phone": "253-418-5940",
        "role": "Co-ordinator",
        "status": "Co-ordinator",
        "unReadChatCount": 0,
        "work_email": "herman_essertg_work@gmil.com",
        "work_phone": "253-418-5940"
    },
    {
        "avatar": "avatar-6.png",
        "birthdayText": "happy Birthday Wilhelmine",
        "company": "ABC Pvt Ltd",
        "id": 6,
        "isFavorite": false,
        "lastMessage": "Yesterday",
        "latestMessage": {
            "message": "Just sent it to your email!",
            "seen": false,
            "time": "2:21 PM"
        },
        "location": "Angola",
        "name": "Wilhelmine Durrg",
        "online_status": "available",
        "personal_email": "wilhelmine_durrg@gmil.com",
        "personal_phone": "380-293-0177",
        "role": "Monitor Evaluator",
        "status": "Monitor Evaluator",
        "unReadChatCount": 0,
        "work_email": "wilhelmine_durrg_work@gmil.com",
        "work_phone": "380-293-0177"
    },
    {
        "avatar": "avatar-7.png",
        "birthdayText": "happy Birthday Agilulf",
        "company": "ABC Pvt Ltd",
        "id": 7,
        "isFavorite": false,
        "lastMessage": "Yesterday",
        "latestMessage": {
            "message": "Awesome, thanks for setting that up!",
            "seen": true,
            "time": "6:01 PM"
        },
        "location": "Antigua and Barbuda",
        "name": "Agilulf Fuxg",
        "online_status": "available",
        "personal_email": "agilulf_fuxg@gmil.com",
        "personal_phone": "253-418-5940",
        "role": "Specialist",
        "status": "Specialist",
        "unReadChatCount": 0,
        "work_email": "agilulf_fuxg_work@gmil.com",
        "work_phone": "253-418-5940"
    },
    {
        "avatar": "avatar-6.png",
        "birthdayText": "happy Birthday Adaline",
        "company": "ABC Pvt Ltd",
        "id": 8,
        "isFavorite": false,
        "lastMessage": "20 Aug",
        "latestMessage": {
            "message": "Great to hear! Let me know if they need more examples.",
            "seen": false,
            "time": "11:01 AM"
        },
        "location": "Argentina",
        "name": "Adaline Bergfalks",
        "online_status": "offline",
        "personal_email": "adaline_bergfalks@gmil.com",
        "personal_phone": "253-118-5940",
        "role": "Shaper",
        "status": "Shaper",
        "unReadChatCount": 0,
        "work_email": "adaline_bergfalks_work@gmil.com",
        "work_phone": "253-118-5940"
    },
    {
        "avatar": "avatar-1.png",
        "birthdayText": "happy Birthday Eadwulf",
        "company": "ABC Pvt Ltd",
        "id": 9,
        "isFavorite": false,
        "lastMessage": "20 Aug",
        "latestMessage": {
            "message": "Thanks for your help debugging!",
            "seen": true,
            "time": "9:51 AM"
        },
        "location": "Armenia",
        "name": "Eadwulf Beckete",
        "online_status": "offline",
        "personal_email": "eadwulf_beckete@gmil.com",
        "personal_phone": "153-418-5940",
        "role": "Implementer",
        "status": "Implementer",
        "unReadChatCount": 0,
        "work_email": "eadwulf_beckete_work@gmil.com",
        "work_phone": "153-418-5940"
    },
    {
        "avatar": "avatar-2.png",
        "birthdayText": "happy Birthday Midas",
        "company": "ABC Pvt Ltd",
        "id": 10,
        "isFavorite": true,
        "lastMessage": "19 Aug",
        "latestMessage": {
            "message": "Thanks! Glad it was helpful.",
            "seen": true,
            "time": "5:01 PM"
        },
        "location": "Australia",
        "name": "Midas",
        "online_status": "offline",
        "personal_email": "midas@gmil.com",
        "personal_phone": "252-418-5940",
        "role": "Leader",
        "status": "Leader",
        "unReadChatCount": 0,
        "work_email": "midas_work@gmil.com",
        "work_phone": "252-418-5940"
    },
    {
        "avatar": "avatar-3.png",
        "birthdayText": "happy Birthday Uranus",
        "company": "ABC Pvt Ltd",
        "id": 11,
        "isFavorite": false,
        "lastMessage": "19 Aug",
        "latestMessage": {
            "message": "Perfect! Thanks for handling the deployment.",
            "seen": true,
            "time": "8:01 AM"
        },
        "location": "Austria",
        "name": "Uranus",
        "online_status": "available",
        "personal_email": "uranus@gmil.com",
        "personal_phone": "253-218-5940",
        "role": "Facilitator",
        "status": "Facilitator",
        "unReadChatCount": 0,
        "work_email": "uranus_work@gmil.com",
        "work_phone": "253-218-5940"
    },
    {
        "avatar": "avatar-4.png",
        "birthdayText": "happy Birthday Peahen",
        "company": "ABC Pvt Ltd",
        "id": 12,
        "isFavorite": false,
        "lastMessage": "18 Aug",
        "latestMessage": {
            "message": "Thanks for reviewing the code so quickly!",
            "seen": true,
            "time": "3:51 PM"
        },
        "location": "Azerbaijan",
        "name": "Peahen",
        "online_status": "do_not_disturb",
        "personal_email": "peahen@gmil.com",
        "personal_phone": "253-418-1940",
        "role": "Coach",
        "status": "One of the Graces.",
        "unReadChatCount": 0,
        "work_email": "peahen_work@gmil.com",
        "work_phone": "253-418-1940"
    },
    {
        "avatar": "avatar-5.png",
        "birthdayText": "happy Birthday Menelaus",
        "company": "ABC Pvt Ltd",
        "id": 13,
        "isFavorite": false,
        "lastMessage": "18 Aug",
        "latestMessage": {
            "message": "That's awesome news! Thanks for sharing.",
            "seen": true,
            "time": "6:31 PM"
        },
        "location": "Bahamas",
        "name": "Menelaus",
        "online_status": "offline",
        "personal_email": "menelaus@gmil.com",
        "personal_phone": "053-418-5940",
        "role": "Facilitator",
        "status": "To stay",
        "unReadChatCount": 0,
        "work_email": "menelaus_work@gmil.com",
        "work_phone": "053-418-5940"
    },
    {
        "avatar": "group-frontend.png",
        "id": 14,
        "isFavorite": false,
        "isGroup": true,
        "lastMessage": "09:00 AM",
        "latestMessage": {
            "message": "Let's finalize the UI components by tomorrow.",
            "seen": true,
            "time": "09:00 AM"
        },
        "members": [
            "Alene",
            "Keefe",
            "Lazaro",
            "Hazle"
        ],
        "name": "Frontend Team",
        "online_status": "active",
        "status": "Project: Website Redesign",
        "unReadChatCount": 0
    }
]



export const CUSTOMER_LIST: CustomerList[] = [
    {
        "about": "Worbov fuggodbe uvawo za rimpewej uc wehele comi buan wam mes gacebu meb fupgop webkem gon enmile.",
        "age": 39,
        "avatar": 8,
        "contact": "(731) 342-9783",
        "country": "Canada",
        "date": "29.07.2023",
        "email": "sip@gmail.com",
        "fatherName": "Isaac McGee",
        "firstName": "Joe",
        "gender": "Female",
        "id": 1,
        "lastName": "Schilder",
        "location": "1631 Melgu Square, Ujdeme, Maldives - 56391",
        "name": "Joe Schilder",
        "orderStatus": "Dispatched",
        "orders": 9603,
        "progress": 44,
        "role": "Scientific Writer",
        "skills": [
            "Wireframing",
            "Figma",
            "Web App",
            "ES6",
            "UX",
            "Javascript"
        ],
        "status": 3,
        "time": [
            "2 days ago"
        ]
    },
    {
        "about": "Udukaape gozune jig fu foslinan tadka kumu no guw upe or cifdasbej di ige.",
        "age": 52,
        "avatar": 8,
        "contact": "(887) 744-6950",
        "country": "Thailand",
        "date": "14.07.2023",
        "email": "ke@gmail.com",
        "fatherName": "Helen Stewart",
        "firstName": "Phoebe",
        "gender": "Female",
        "id": 2,
        "lastName": "Venturi",
        "location": "1804 Ahedi Trail, Owottug, Bolivia - 47403",
        "name": "Phoebe Venturi",
        "orderStatus": "Delivered",
        "orders": 7174,
        "progress": 84,
        "role": "Logistics Manager",
        "skills": [
            "React",
            "Mobile App",
            "Prototyping",
            "UX",
            "Figma"
        ],
        "status": 1,
        "time": [
            "1 day ago"
        ]
    },
    {
        "about": "Totug amuovve cakwud amlevat ja gepsi zan bulfivki mij dultej etuuf dakirpe.",
        "age": 45,
        "avatar": 4,
        "contact": "(618) 787-3453",
        "country": "Barbados",
        "date": "10.07.2023",
        "email": "secjavkib@gmail.com",
        "fatherName": "Herbert Todd",
        "firstName": "Caroline",
        "gender": "Female",
        "id": 3,
        "lastName": "Pandolfi",
        "location": "1060 Ejeaba Square, Wouruno, Congo - Kinshasa - 24456",
        "name": "Caroline Pandolfi",
        "orderStatus": "Cancelled",
        "orders": 2585,
        "progress": 16,
        "role": "Physicist",
        "skills": [
            "ES6",
            "Figma",
            "Backend",
            "Mobile App",
            "Javascript"
        ],
        "status": 1,
        "time": [
            "1 year ago"
        ]
    },
    {
        "about": "Riv mi hudgoh esviwoc usojipa vub palbesdu det vies pop rutsenazo viwwij esedakvu novfovih afjoda cimuwiec ebve.",
        "age": 29,
        "avatar": 5,
        "contact": "(415) 628-7505",
        "country": "Italy",
        "date": "2.07.2023",
        "email": "ho@gmail.com",
        "fatherName": "Gerald Patterson",
        "firstName": "Ricardo",
        "gender": "Female",
        "id": 4,
        "lastName": "Marchetti",
        "location": "1614 Fomwaj Square, Eknisra, Iceland - 41340",
        "name": "Ricardo Marchetti",
        "orderStatus": "Refunded",
        "orders": 9283,
        "progress": 48,
        "role": "Banker",
        "skills": [
            "Codeigniter",
            "Wireframing",
            "Angular",
            "Backend",
            "UX",
            "UI Design"
        ],
        "status": 1,
        "time": [
            "1 week ago"
        ]
    },
    {
        "about": "Avureput etluh iketi vosfo jamow do junabgog biw tovwenil fezpa aneow cizhel.",
        "age": 58,
        "avatar": 6,
        "contact": "(856) 459-8945",
        "country": "Mauritius",
        "date": "30.06.2023",
        "email": "socuih@gmail.com",
        "fatherName": "Henrietta Griffin",
        "firstName": "Dorothy",
        "gender": "Female",
        "id": 5,
        "lastName": "Hussain",
        "location": "1397 Morco Path, Gamarib, Malta - 65124",
        "name": "Dorothy Hussain",
        "orderStatus": "Delivered",
        "orders": 4872,
        "progress": 26,
        "role": "International Acct.",
        "skills": [
            "Codeigniter",
            "Angular",
            "UI Design",
            "Backend",
            "React"
        ],
        "status": 2,
        "time": [
            "2 days ago"
        ]
    },
    {
        "about": "Ciaj dubeco muzogho bunwe ogtafa nij fizanul nopgoomu wuf hiwop tot ser wefoz uhe anaced.",
        "age": 60,
        "avatar": 2,
        "contact": "(507) 561-6927",
        "country": "American Samoa",
        "date": "22.06.2023",
        "email": "jonvok@gmail.com",
        "fatherName": "Dollie Griffin",
        "firstName": "Eleanor",
        "gender": "Male",
        "id": 6,
        "lastName": "Mann",
        "location": "25 Odvaz Grove, Nadrubo, Belize - 93095",
        "name": "Eleanor Mann",
        "orderStatus": "Dispatched",
        "orders": 499,
        "progress": 8,
        "role": "Design Engineer",
        "skills": [
            "Codeigniter",
            "Figma"
        ],
        "status": 3,
        "time": [
            "1 hour ago"
        ]
    },
    {
        "about": "Besilija zomka nijiso puadehaz ve pi ecpogapo cotesen ceuje hohih ewuiw bo.",
        "age": 27,
        "avatar": 3,
        "contact": "(722) 952-7792",
        "country": "Gibraltar",
        "date": "18.06.2023",
        "email": "uhudadof@gmail.com",
        "fatherName": "Danny Cohen",
        "firstName": "Nina",
        "gender": "Male",
        "id": 7,
        "lastName": "Francini",
        "location": "1984 Faza Point, Wakukda, India - 94335",
        "name": "Nina Francini",
        "orderStatus": "Shipped",
        "orders": 3066,
        "progress": 73,
        "role": "Aerospace Engineer",
        "skills": [
            "Angular",
            "Javascript",
            "React"
        ],
        "status": 1,
        "time": [
            "1 hour ago"
        ]
    },
    {
        "about": "Asowag me ogetem gir joaw ki cuhug lakvo ujesa volhuj rettu powpa agoku va gajpah kinulov gechubte.",
        "age": 26,
        "avatar": 5,
        "contact": "(675) 882-6307",
        "country": "Central African Republic",
        "date": "5.06.2023",
        "email": "peg@gmail.com",
        "fatherName": "Phoebe Hanson",
        "firstName": "Caroline",
        "gender": "Female",
        "id": 8,
        "lastName": "Mallet",
        "location": "725 Zehvo Highway, Puvoef, Japan - 93292",
        "name": "Caroline Mallet",
        "orderStatus": "Processing",
        "orders": 5478,
        "progress": 24,
        "role": "Director",
        "skills": [
            "Web App",
            "Prototyping",
            "Wireframing"
        ],
        "status": 3,
        "time": [
            "1 hour ago"
        ]
    },
    {
        "about": "Vo icu re da ula kumgajbeg fuhem wuwe doiso uvoege lu ipekocpub.",
        "age": 47,
        "avatar": 3,
        "contact": "(906) 966-2597",
        "country": "Indonesia",
        "date": "31.05.2023",
        "email": "vavceriji@gmail.com",
        "fatherName": "Harriett Gonzales",
        "firstName": "Amy",
        "gender": "Female",
        "id": 9,
        "lastName": "Pratt",
        "location": "333 Hinur Trail, Zepopde, Kiribati - 39279",
        "name": "Amy Pratt",
        "orderStatus": "Refunded",
        "orders": 6255,
        "progress": 6,
        "role": "Urban Planner",
        "skills": [
            "Backend",
            "UI Design"
        ],
        "status": 1,
        "time": [
            "5 months ago"
        ]
    },
    {
        "about": "Ro atvawvih somhek nipdoni hotfaltab mujle etajevuj ra pev mi duzahi redka se mab dem rorjeab tel hiwehar.",
        "age": 55,
        "avatar": 4,
        "contact": "(969) 819-7489",
        "country": "Yemen",
        "date": "13.05.2023",
        "email": "rouca@gmail.com",
        "fatherName": "Mason Brady",
        "firstName": "Gene",
        "gender": "Male",
        "id": 10,
        "lastName": "Montero",
        "location": "1409 Ifuwu Trail, Davdibun, Nepal - 22947",
        "name": "Gene Montero",
        "orderStatus": "Delivered",
        "orders": 702,
        "progress": 62,
        "role": "Administrator",
        "skills": [
            "Javascript",
            "Figma",
            "HTML"
        ],
        "status": 2,
        "time": [
            "1 day ago"
        ]
    },
    {
        "about": "Igalewuh idpowu tivwi zedro pidfufbic juz ot kor beb wopaeha ughema odi ebwuco ju.",
        "age": 64,
        "avatar": 8,
        "contact": "(323) 498-6272",
        "country": "Central African Republic",
        "date": "27.04.2023",
        "email": "bap@gmail.com",
        "fatherName": "Nina Stanley",
        "firstName": "Ollie",
        "gender": "Female",
        "id": 11,
        "lastName": "Barbetti",
        "location": "577 Zeoz Drive, Misoov, Martinique - 29073",
        "name": "Ollie Barbetti",
        "orderStatus": "Dispatched",
        "orders": 8006,
        "progress": 88,
        "role": "City Housing Manager",
        "skills": [
            "Javascript",
            "Prototyping"
        ],
        "status": 2,
        "time": [
            "1 year ago"
        ]
    },
    {
        "about": "Gajvaj mam won wo azeovoz mo ki apa bukihroh po lati takobada.",
        "age": 41,
        "avatar": 4,
        "contact": "(740) 673-7034",
        "country": "Nicaragua",
        "date": "6.04.2023",
        "email": "newe@gmail.com",
        "fatherName": "Harold Fowler",
        "firstName": "Katherine",
        "gender": "Female",
        "id": 12,
        "lastName": "Olivier",
        "location": "1563 Kukrez River, Vegotaf, Tristan da Cunha - 54129",
        "name": "Katherine Olivier",
        "orderStatus": "Completed",
        "orders": 261,
        "progress": 68,
        "role": "Jeweler",
        "skills": [
            "Figma",
            "React"
        ],
        "status": 2,
        "time": [
            "2 days ago"
        ]
    },
    {
        "about": "Jiloki uvma vonfovic onu ej upuza ih hitwotmac odowa jicfu sunas gut uk edwaama zehwake lonevwa.",
        "age": 62,
        "avatar": 9,
        "contact": "(571) 692-3845",
        "country": "Northern Mariana Islands",
        "date": "20.03.2023",
        "email": "at@gmail.com",
        "fatherName": "Harold Goodman",
        "firstName": "Fanny",
        "gender": "Male",
        "id": 13,
        "lastName": "Renault",
        "location": "755 Siar Ridge, Niedme, Sudan - 61803",
        "name": "Fanny Renault",
        "orderStatus": "Shipped",
        "orders": 2924,
        "progress": 30,
        "role": "Communications Engineer",
        "skills": [
            "UI Design",
            "Figma",
            "Wireframing",
            "ES6",
            "UX",
            "Backend"
        ],
        "status": 3,
        "time": [
            "1 week ago"
        ]
    },
    {
        "about": "Dad wehut do few rikbihlum favejazat zuwe osowehes elituri me sobgiz mif ci ozmebfi.",
        "age": 31,
        "avatar": 6,
        "contact": "(608) 235-8613",
        "country": "Greenland",
        "date": "03.03.2023",
        "email": "bovli@gmail.com",
        "fatherName": "Susie Fowler",
        "firstName": "Dean",
        "gender": "Female",
        "id": 14,
        "lastName": "McCarthy",
        "location": "1609 Esegov Key, Casapop, Kenya - 74802",
        "name": "Dean McCarthy",
        "orderStatus": "Refunded",
        "orders": 1809,
        "progress": 40,
        "role": "Film Producer",
        "skills": [
            "Figma",
            "UX",
            "Web App",
            "React",
            "Wireframing"
        ],
        "status": 2,
        "time": [
            "3 hours ago"
        ]
    },
    {
        "about": "Okaiguki ni hisnunas vem po wi wekha arduglo cantacoh vankurzo sav jisa kiviw sibosot ek jom ercezziw.",
        "age": 47,
        "avatar": 6,
        "contact": "(623) 270-6754",
        "country": "Afghanistan",
        "date": "28.02.2023",
        "email": "naborga@gmail.com",
        "fatherName": "Noah Huff",
        "firstName": "Kyle",
        "gender": "Female",
        "id": 15,
        "lastName": "Papucci",
        "location": "155 Lajac Square, Otozicut, Ghana - 99354",
        "name": "Kyle Papucci",
        "orderStatus": "Delivered",
        "orders": 7957,
        "progress": 66,
        "role": "Scientific Writer",
        "skills": [
            "HTML",
            "Figma",
            "Prototyping",
            "Wireframing",
            "ES6"
        ],
        "status": 1,
        "time": [
            "just now"
        ]
    },
    {
        "about": "Ram pujtut mi rik rok ove dim wavzuw awewikoz it dukrawe ojevi uhnujus jaonil.",
        "age": 51,
        "avatar": 10,
        "contact": "(646) 585-1373",
        "country": "Comoros",
        "date": "19.02.2023",
        "email": "rempesdel@gmail.com",
        "fatherName": "Willie Ward",
        "firstName": "Clifford",
        "gender": "Female",
        "id": 16,
        "lastName": "Hayes",
        "location": "1776 Gide Glen, Fizogeh, Kuwait - 75148",
        "name": "Clifford Hayes",
        "orderStatus": "Processing",
        "orders": 4636,
        "progress": 92,
        "role": "Park Ranger",
        "skills": [
            "Angular",
            "Figma",
            "Backend",
            "UI Design"
        ],
        "status": 2,
        "time": [
            "2 days ago"
        ]
    },
    {
        "about": "Owanih ilevgi eja huz waipi kufe wi he muvir ogurasu zos bibtuw aj ge zi peadoc jeckibu.",
        "age": 35,
        "avatar": 3,
        "contact": "(857) 597-2624",
        "country": "Pitcairn Islands",
        "date": "2.02.2023",
        "email": "watjoap@gmail.com",
        "fatherName": "Willie Stone",
        "firstName": "Daisy",
        "gender": "Female",
        "id": 17,
        "lastName": "Andres",
        "location": "1165 Ifcil Glen, Fejafma, British Indian Ocean Territory - 42333",
        "name": "Daisy Andres",
        "orderStatus": "Processing",
        "orders": 9852,
        "progress": 65,
        "role": "Biotechnical Researcher",
        "skills": [
            "ES6",
            "HTML"
        ],
        "status": 3,
        "time": [
            "2 min ago"
        ]
    },
    {
        "about": "Zopescoh usawehfo erutu wicitu izokudro ivpuzup laer time mos ke poebotu wuovito.",
        "age": 42,
        "avatar": 8,
        "contact": "(881) 700-1479",
        "country": "Japan",
        "date": "27.01.2023",
        "email": "pi@gmail.com",
        "fatherName": "Rosetta Robbins",
        "firstName": "Ronald",
        "gender": "Male",
        "id": 18,
        "lastName": "Bentley",
        "location": "1333 Faed River, Gonvison, Bahrain - 01190",
        "name": "Ronald Bentley",
        "orderStatus": "Delivered",
        "orders": 1125,
        "progress": 18,
        "role": "Baker",
        "skills": [
            "Prototyping",
            "Javascript",
            "UX",
            "Codeigniter",
            "Web App"
        ],
        "status": 1,
        "time": [
            "1 day ago"
        ]
    },
    {
        "about": "Gih juintak zupiko abe funefeg isoze buwaj ifiuvupi zu daditcak uji irute loj.",
        "age": 38,
        "avatar": 3,
        "contact": "(624) 971-8666",
        "country": "Martinique",
        "date": "14.01.2023",
        "email": "irlizih@gmail.com",
        "fatherName": "Christian Peters",
        "firstName": "Warren",
        "gender": "Female",
        "id": 19,
        "lastName": "Ridolfi",
        "location": "801 Havul Heights, Ratudu, Lithuania - 24321",
        "name": "Warren Ridolfi",
        "orderStatus": 2,
        "orders": 9887,
        "progress": 96,
        "role": "Investment Manager",
        "skills": [
            "UX",
            "Web App",
            "UI Design",
            "Javascript",
            "Figma"
        ],
        "status": 3,
        "time": [
            "1 hour ago"
        ]
    },
    {
        "about": "Dusogov muk uzuebgig huwpubem to dihov azvewo ovo uwkuuk dejpik tized ra tezku.",
        "age": 47,
        "avatar": 1,
        "contact": "(407) 444-2699",
        "country": "Laos",
        "date": "7.01.2023",
        "email": "bonnollol@gmail.com",
        "fatherName": "Elizabeth McGuire",
        "firstName": "Cecelia",
        "gender": "Male",
        "id": 20,
        "lastName": "Le GallGall",
        "location": "717 Evdi Junction, Usehodwar, Mauritius - 90065",
        "name": "Cecelia Le GallGall",
        "orderStatus": "Completed",
        "orders": 1421,
        "progress": 30,
        "role": "Chemical Engineer",
        "skills": [
            "Javascript",
            "Mobile App"
        ],
        "status": 2,
        "time": [
            "2 min ago"
        ]
    },
    {
        "about": "Nagfivmah fepuj wum unfo zodpuc tapjus kemitunat vacve inicug nujvezti va ku ni nos.",
        "age": 28,
        "avatar": 3,
        "contact": "(668) 801-3695",
        "country": "St. Helena",
        "date": "31.12.2022",
        "email": "obi@gmail.com",
        "fatherName": "Dale Wolfe",
        "firstName": "Bessie",
        "gender": "Female",
        "id": 21,
        "lastName": "James",
        "location": "828 Igake Pass, Ebojiire, French Polynesia - 75187",
        "name": "Bessie James",
        "orderStatus": 2,
        "orders": 4005,
        "progress": 96,
        "role": "Horticulturist",
        "skills": [
            "Web App",
            "UI Design"
        ],
        "status": 3,
        "time": [
            "3 hours ago"
        ]
    },
    {
        "about": "Suscagu hogutol mici fatgi turkizij vavbinci pihin iwiz zu abhow coihugo ledozi sulga.",
        "age": 62,
        "avatar": 4,
        "contact": "(379) 241-7855",
        "country": "Azerbaijan",
        "date": "10.12.2022",
        "email": "big@gmail.com",
        "fatherName": "Barbara Arnold",
        "firstName": "Andrew",
        "gender": "Female",
        "id": 22,
        "lastName": "Brown",
        "location": "256 Hajuv Grove, Ubrapwaj, Oman - 95099",
        "name": "Andrew Brown",
        "orderStatus": "Delivered",
        "orders": 1119,
        "progress": 73,
        "role": "Preschool Management",
        "skills": [
            "HTML",
            "Web App",
            "Wireframing",
            "Javascript",
            "React",
            "Codeigniter"
        ],
        "status": 1,
        "time": [
            "5 months ago"
        ]
    },
    {
        "about": "Zoljuf jenpap lirbemuf nerak luwuri cohsa hucu do imo giczovo win logaw sejev dazwut fabitjim tadketwa sedo onimepi.",
        "age": 47,
        "avatar": 6,
        "contact": "(465) 759-3060",
        "country": "Macau SAR China",
        "date": "22.11.2022",
        "email": "ivgukon@gmail.com",
        "fatherName": "Ralph Delgado",
        "firstName": "Curtis",
        "gender": "Female",
        "id": 23,
        "lastName": "Lazzeri",
        "location": "823 Ubtav River, Gegohsi, American Samoa - 22889",
        "name": "Curtis Lazzeri",
        "orderStatus": "Processing",
        "orders": 1393,
        "progress": 6,
        "role": "Sales Engineer",
        "skills": [
            "Codeigniter",
            "UX",
            "Prototyping",
            "Angular",
            "Backend"
        ],
        "status": 2,
        "time": [
            "2 min ago"
        ]
    },
    {
        "about": "Envem tejonte oli ocjojdet bag bezilfiz celor azaowsa nuzuic jifo gew tiwdoz zuzfefofa gewhigu.",
        "age": 36,
        "avatar": 5,
        "contact": "(372) 671-4732",
        "country": "Cayman Islands",
        "date": "4.11.2022",
        "email": "ac@gmail.com",
        "fatherName": "Stephen Patrick",
        "firstName": "Charlie",
        "gender": "Female",
        "id": 24,
        "lastName": "Jensen",
        "location": "1380 Mofgo Pass, Palutu, Portugal - 65273",
        "name": "Charlie Jensen",
        "orderStatus": "Cancelled",
        "orders": 4304,
        "progress": 80,
        "role": "Broker",
        "skills": [
            "Backend",
            "React"
        ],
        "status": 3,
        "time": [
            "2 days ago"
        ]
    },
    {
        "about": "Ivo udu vekra madih atisidufe vomcilo rejo pepo guidfit tavitifi ebi fobamzak cucuz.",
        "age": 44,
        "avatar": 4,
        "contact": "(201) 535-5050",
        "country": "St. Helena",
        "date": "16.10.2022",
        "email": "pecmu@gmail.com",
        "fatherName": "Allie Jensen",
        "firstName": "Gordon",
        "gender": "Female",
        "id": 25,
        "lastName": "Cummings",
        "location": "1714 Gevher Drive, Emgawbo, Canada - 26706",
        "name": "Gordon Cummings",
        "orderStatus": "Completed",
        "orders": 561,
        "progress": 27,
        "role": "Executive Recruiter",
        "skills": [
            "Prototyping",
            "UX",
            "Codeigniter",
            "HTML",
            "Figma"
        ],
        "status": 1,
        "time": [
            "1 day ago"
        ]
    },
    {
        "about": "Ewuvudi ge mamdomev jugelo rasas gazo adetonomi mir rekvopo avgig pi juoni cuaze.",
        "age": 56,
        "avatar": 3,
        "contact": "(722) 720-9964",
        "country": "Colombia",
        "date": "24.09.2022",
        "email": "tukzuc@gmail.com",
        "fatherName": "Carlos Lyons",
        "firstName": "Lottie",
        "gender": "Female",
        "id": 26,
        "lastName": "Yang",
        "location": "1952 Taib Pass, Wiwinoh, New Zealand - 75651",
        "name": "Lottie Yang",
        "orderStatus": "Shipped",
        "orders": 143,
        "progress": 69,
        "role": "Relocation Manager",
        "skills": [
            "Codeigniter",
            "Figma",
            "ES6",
            "Web App",
            "UI Design"
        ],
        "status": 1,
        "time": [
            "5 months ago"
        ]
    },
    {
        "about": "Womgopeg nelram gehiden himsup putget wera okuzisof viectoz aj nivpacwe du cuflok muf mekfokuf cu ovcu heko mizso.",
        "age": 22,
        "avatar": 2,
        "contact": "(246) 804-3900",
        "country": "Hong Kong SAR China",
        "date": "11.09.2022",
        "email": "awotuwfu@gmail.com",
        "fatherName": "Violet West",
        "firstName": "John",
        "gender": "Female",
        "id": 27,
        "lastName": "Breschi",
        "location": "752 Cuzfez Place, Tepolewa, Honduras - 60622",
        "name": "John Breschi",
        "orderStatus": "Delivered",
        "orders": 1677,
        "progress": 71,
        "role": "Film Production Assistant",
        "skills": [
            "ES6",
            "Prototyping",
            "Javascript",
            "Wireframing",
            "UX",
            "Angular"
        ],
        "status": 3,
        "time": [
            "just now"
        ]
    },
    {
        "about": "Joon ragwijat owfi siijpem tida cohi tilrefe fi padgiigu idhek litce famove ciwima evogu.",
        "age": 27,
        "avatar": 3,
        "contact": "(632) 281-5739",
        "country": "Albania",
        "date": "19.08.2022",
        "email": "zohom@gmail.com",
        "fatherName": "Cornelia Newman",
        "firstName": "Roy",
        "gender": "Male",
        "id": 28,
        "lastName": "Lynch",
        "location": "1299 Babdes Park, Begpube, Greece - 51028",
        "name": "Roy Lynch",
        "orderStatus": 2,
        "orders": 5505,
        "progress": 84,
        "role": "Law Enforcement Officer",
        "skills": [
            "Javascript",
            "Prototyping"
        ],
        "status": 2,
        "time": [
            "1 year ago"
        ]
    },
    {
        "about": "Ba ot geisaino himjepuv zebta dur pohud geluglow en ro juh juh rodezif zimaz puagnam funakozu bumuzifoj.",
        "age": 61,
        "avatar": 9,
        "contact": "(959) 253-7464",
        "country": "Guyana",
        "date": "8.08.2022",
        "email": "siwneapi@gmail.com",
        "fatherName": "Jorge Gill",
        "firstName": "Polly",
        "gender": "Female",
        "id": 29,
        "lastName": "Andrews",
        "location": "111 Buab Turnpike, Wumehkoj, Namibia - 09850",
        "name": "Polly Andrews",
        "orderStatus": "Cancelled",
        "orders": 5961,
        "progress": 45,
        "role": "Actor",
        "skills": [
            "Figma",
            "Codeigniter",
            "ES6",
            "Web App",
            "Prototyping",
            "Backend"
        ],
        "status": 1,
        "time": [
            "2 days ago"
        ]
    },
    {
        "about": "Jos boraw ke ozu tar sushi cinocmok wam ninma kousebij zagefhih sa cajeh.",
        "age": 34,
        "avatar": 7,
        "contact": "(787) 219-8188",
        "country": "U.S. Virgin Islands",
        "date": "18.07.2022",
        "email": "icboz@gmail.com",
        "fatherName": "Barry Rhodes",
        "firstName": "Annie",
        "gender": "Male",
        "id": 30,
        "lastName": "de Vos",
        "location": "1025 Mumej Parkway, Ecjalo, St. Helena - 71462",
        "name": "Annie de Vos",
        "orderStatus": "Cancelled",
        "orders": 5093,
        "progress": 31,
        "role": "Microbiologist",
        "skills": [
            "Wireframing",
            "ES6",
            "Angular",
            "React",
            "Javascript",
            "Mobile App"
        ],
        "status": 2,
        "time": [
            "2 days ago"
        ]
    },
    {
        "about": "Sevmesve zu conimwi juvbat nizziffa wodulzep bu zuvihe bufwin fizocapo fuphe movhosud.",
        "age": 34,
        "avatar": 3,
        "contact": "(463) 498-6562",
        "country": "Palestinian Territories",
        "date": "30.06.2022",
        "email": "iga@gmail.com",
        "fatherName": "Chase Howard",
        "firstName": "Douglas",
        "gender": "Female",
        "id": 31,
        "lastName": "Santi",
        "location": "1860 Edaluh Turnpike, Kakemra, Moldova - 88806",
        "name": "Douglas Santi",
        "orderStatus": "Delivered",
        "orders": 5515,
        "progress": 30,
        "role": "Sales Promotion Manager",
        "skills": [
            "Mobile App",
            "Figma",
            "Wireframing"
        ],
        "status": 2,
        "time": [
            "5 months ago"
        ]
    },
    {
        "about": "Kij gehbedci jub kasdacovi dudvifel mik womenjo pubo dicme japa heno zevosar pe ebu jitgisi.",
        "age": 38,
        "avatar": 6,
        "contact": "(315) 885-4440",
        "country": "Mauritania",
        "date": "3.06.2022",
        "email": "coh@gmail.com",
        "fatherName": "Owen Holt",
        "firstName": "Lester",
        "gender": "Male",
        "id": 32,
        "lastName": "Ceccherini",
        "location": "1887 Wujep Place, Cadulre, Algeria - 30750",
        "name": "Lester Ceccherini",
        "orderStatus": "Completed",
        "orders": 214,
        "progress": 3,
        "role": "Administrator",
        "skills": [
            "Prototyping",
            "ES6",
            "HTML",
            "UX",
            "Mobile App"
        ],
        "status": 3,
        "time": [
            "5 months ago"
        ]
    },
    {
        "about": "Pupocauri cufo wegzi meajhe jisob lezuthal rometfiz ca ori retvipoc no legcuha eginna biti cotikuh ziztov cenno.",
        "age": 30,
        "avatar": 3,
        "contact": "(727) 270-8667",
        "country": "Palau",
        "date": "20.05.2022",
        "email": "lud@gmail.com",
        "fatherName": "Lily Vaughn",
        "firstName": "Martin",
        "gender": "Female",
        "id": 33,
        "lastName": "Pfeiffer",
        "location": "1110 Vaez Terrace, Deoveduw, Sri Lanka - 16001",
        "name": "Martin Pfeiffer",
        "orderStatus": "Processing",
        "orders": 6673,
        "progress": 28,
        "role": "Actor",
        "skills": [
            "HTML",
            "Codeigniter",
            "UX",
            "UI Design",
            "Angular",
            "React"
        ],
        "status": 1,
        "time": [
            "1 day ago"
        ]
    },
    {
        "about": "Fe fuit po kuwag fiaranab zusikfiz pi rorigfas soga ces elimfus sik hob ozhutma ohuika capaom waf vov.",
        "age": 61,
        "avatar": 7,
        "contact": "(468) 907-2161",
        "country": "Norway",
        "date": "6.05.2022",
        "email": "ufe@gmail.com",
        "fatherName": "Michael Holland",
        "firstName": "Jesse",
        "gender": "Female",
        "id": 34,
        "lastName": "Tagliaferri",
        "location": "1882 Lohnun Path, Nizsikuv, Seychelles - 17445",
        "name": "Jesse Tagliaferri",
        "orderStatus": 2,
        "orders": 1401,
        "progress": 68,
        "role": "Network Administrator",
        "skills": [
            "Codeigniter",
            "Wireframing",
            "HTML"
        ],
        "status": 1,
        "time": [
            "1 day ago"
        ]
    },
    {
        "about": "Riplielu soripo imenu kuuhgep lu coef cicwoj varac pih konuje ma ku pu dicpinhe fik.",
        "age": 43,
        "avatar": 5,
        "contact": "(720) 742-5022",
        "country": "Turkey",
        "date": "17.04.2022",
        "email": "iwifoesi@gmail.com",
        "fatherName": "Jeffery Thompson",
        "firstName": "Wayne",
        "gender": "Female",
        "id": 35,
        "lastName": "Peters",
        "location": "219 Melapa Pike, Bazuhol, Mexico - 17857",
        "name": "Wayne Peters",
        "orderStatus": "Completed",
        "orders": 9204,
        "progress": 56,
        "role": "Broker",
        "skills": [
            "Codeigniter",
            "HTML"
        ],
        "status": 1,
        "time": [
            "1 year ago"
        ]
    },
    {
        "about": "Dolom na co fedvob mikugus roceoli javholduf foh avoleto wavuj paziju tefvon owe.",
        "age": 37,
        "avatar": 1,
        "contact": "(888) 563-2573",
        "country": "Paraguay",
        "date": "28.03.2022",
        "email": "roga@gmail.com",
        "fatherName": "Gene French",
        "firstName": "Lee",
        "gender": "Male",
        "id": 36,
        "lastName": "Cinelli",
        "location": "725 Hifho Extension, Heigcos, Kuwait - 67796",
        "name": "Lee Cinelli",
        "orderStatus": 2,
        "orders": 3386,
        "progress": 93,
        "role": "Sales Trainer",
        "skills": [
            "Mobile App",
            "Javascript",
            "Angular",
            "UI Design"
        ],
        "status": 3,
        "time": [
            "just now"
        ]
    },
    {
        "about": "Tu wa citedvat je ehuksi jir uvcop udocuate cunjes egevne futobu du cizfi dukvaf owpu ughudju.",
        "age": 29,
        "avatar": 4,
        "contact": "(240) 975-7074",
        "country": "Gibraltar",
        "date": "9.03.2022",
        "email": "satdoj@gmail.com",
        "fatherName": "Johanna Cox",
        "firstName": "Mason",
        "gender": "Female",
        "id": 37,
        "lastName": "Cobb",
        "location": "1903 Tulof Highway, Gimbupfe, Bahamas - 65012",
        "name": "Mason Cobb",
        "orderStatus": "Processing",
        "orders": 14,
        "progress": 8,
        "role": "Managed Care Director",
        "skills": [
            "Angular",
            "Figma",
            "Javascript",
            "React",
            "ES6",
            "Backend"
        ],
        "status": 1,
        "time": [
            "just now"
        ]
    },
    {
        "about": "Nenwi mu ci bu pabegfi limopanav pil liwra po sis tukutsel po wipzozsid aki pilogifu.",
        "age": 29,
        "avatar": 7,
        "contact": "(479) 425-1698",
        "country": "Montserrat",
        "date": "26.02.2022",
        "email": "ehfakse@gmail.com",
        "fatherName": "Brett Brady",
        "firstName": "Leona",
        "gender": "Male",
        "id": 38,
        "lastName": "Maffei",
        "location": "762 Zoave Circle, Pujerhor, Canary Islands - 38978",
        "name": "Leona Maffei",
        "orderStatus": "Completed",
        "orders": 2195,
        "progress": 20,
        "role": "Architect",
        "skills": [
            "Wireframing",
            "Javascript",
            "React",
            "Angular",
            "ES6"
        ],
        "status": 3,
        "time": [
            "1 hour ago"
        ]
    },
    {
        "about": "To nuwogi cegelasa jefiag subgo helijmoz reasi da voz giz tobfegan ji.",
        "age": 64,
        "avatar": 3,
        "contact": "(503) 484-7921",
        "country": "Faroe Islands",
        "date": "5.02.2022",
        "email": "bibojdi@gmail.com",
        "fatherName": "Max Kelly",
        "firstName": "Willie",
        "gender": "Male",
        "id": 39,
        "lastName": "Koek",
        "location": "1894 Poppog Place, Pabzifcu, Ascension Island - 76394",
        "name": "Willie Koek",
        "orderStatus": "Processing",
        "orders": 4628,
        "progress": 59,
        "role": "Fashion Events Manager",
        "skills": [
            "UX",
            "UI Design",
            "Prototyping",
            "ES6",
            "Javascript"
        ],
        "status": 2,
        "time": [
            "1 hour ago"
        ]
    },
    {
        "about": "Mow to pi werbavvej wan filcail nu duaji jisbo teljig veignem polnewhol bontelil pa kunza otucisuw vekuvu reseljup.",
        "age": 39,
        "avatar": 2,
        "contact": "(732) 390-4096",
        "country": "Cuba",
        "date": "26.01.2022",
        "email": "jazi@gmail.com",
        "fatherName": "Mike Tucker",
        "firstName": "Bobby",
        "gender": "Male",
        "id": 40,
        "lastName": "Vignolini",
        "location": "1125 Pamu Avenue, Igpetsa, Denmark - 49026",
        "name": "Bobby Vignolini",
        "orderStatus": "Dispatched",
        "orders": 1217,
        "progress": 42,
        "role": "Manpower Planner",
        "skills": [
            "Angular",
            "Web App",
            "Mobile App",
            "Prototyping",
            "UI Design",
            "Wireframing"
        ],
        "status": 1,
        "time": [
            "5 months ago"
        ]
    },
    {
        "about": "Rerusa wij ki hodwobiw eddu biuha tiub lanuf fi etbose uzuirood pignac zos.",
        "age": 62,
        "avatar": 4,
        "contact": "(907) 691-7968",
        "country": "Macau SAR China",
        "date": "1.01.2022",
        "email": "odowik@gmail.com",
        "fatherName": "Alice Walters",
        "firstName": "Lettie",
        "gender": "Female",
        "id": 41,
        "lastName": "Scarpelli",
        "location": "1388 Wuzub Road, Multabtov, El Salvador - 67114",
        "name": "Lettie Scarpelli",
        "orderStatus": "Processing",
        "orders": 1319,
        "progress": 92,
        "role": "Optometrist",
        "skills": [
            "Javascript",
            "Mobile App",
            "Figma"
        ],
        "status": 1,
        "time": [
            "3 hours ago"
        ]
    },
    {
        "about": "Wufahogov iv buspaz uge ja okozo gi amijo gune ta zoodedit mezi bavanwet dupesbi si jiwa elwu wejzosu.",
        "age": 30,
        "avatar": 8,
        "contact": "(245) 679-7532",
        "country": "Singapore",
        "date": "21.12.2021",
        "email": "lujos@gmail.com",
        "fatherName": "Victor Bush",
        "firstName": "Marguerite",
        "gender": "Male",
        "id": 42,
        "lastName": "Lord",
        "location": "1512 Tubu View, Jetosuvar, Tajikistan - 43758",
        "name": "Marguerite Lord",
        "orderStatus": "Processing",
        "orders": 6677,
        "progress": 0,
        "role": "Financial Analyst",
        "skills": [
            "React",
            "HTML"
        ],
        "status": 3,
        "time": [
            "1 year ago"
        ]
    },
    {
        "about": "Al sefniguf jeromwi go aj mizmodugi gur hif meavti nu nuwi ceripdu rujorri ticbazluz.",
        "age": 24,
        "avatar": 8,
        "contact": "(509) 418-3628",
        "country": "Cyprus",
        "date": "23.11.2021",
        "email": "nol@gmail.com",
        "fatherName": "Barry Pierce",
        "firstName": "Gussie",
        "gender": "Male",
        "id": 43,
        "lastName": "Webster",
        "location": "1365 Vupe Plaza, Pukleodu, Ukraine - 14929",
        "name": "Gussie Webster",
        "orderStatus": "Dispatched",
        "orders": 276,
        "progress": 24,
        "role": "Building Manager",
        "skills": [
            "React",
            "ES6",
            "Web App",
            "HTML",
            "Mobile App",
            "Backend"
        ],
        "status": 3,
        "time": [
            "3 hours ago"
        ]
    },
    {
        "about": "Ciwokafi nafo nodokeb ven bopo ijiosidum riszo kegtevoju wo ido kenudko nit law.",
        "age": 18,
        "avatar": 6,
        "contact": "(642) 346-8267",
        "country": "Grenada",
        "date": "29.10.2021",
        "email": "ka@gmail.com",
        "fatherName": "Anthony Andrews",
        "firstName": "Jonathan",
        "gender": "Female",
        "id": 44,
        "lastName": "Medina",
        "location": "977 Epocof Grove, Loitpa, Dominican Republic - 19736",
        "name": "Jonathan Medina",
        "orderStatus": "Completed",
        "orders": 4909,
        "progress": 72,
        "role": "Electro Optical Engineer",
        "skills": [
            "Figma",
            "ES6",
            "Angular",
            "UX",
            "HTML"
        ],
        "status": 1,
        "time": [
            "1 year ago"
        ]
    },
    {
        "about": "Mukared cekeva ugoliube rourhir suto bo wetcat tarjujik guhvuif dofac ro favos.",
        "age": 33,
        "avatar": 4,
        "contact": "(531) 480-8578",
        "country": "Bahamas",
        "date": "13.09.2021",
        "email": "kapna@gmail.com",
        "fatherName": "Mary Stevenson",
        "firstName": "Mamie",
        "gender": "Male",
        "id": 45,
        "lastName": "Birch",
        "location": "1177 Ubomu Trail, Vegojluz, Canary Islands - 60702",
        "name": "Mamie Birch",
        "orderStatus": 2,
        "orders": 3627,
        "progress": 6,
        "role": "Consultant",
        "skills": [
            "Javascript",
            "Mobile App",
            "Figma"
        ],
        "status": 1,
        "time": [
            "5 months ago"
        ]
    },
    {
        "about": "Ti kuccij odo uraam rirkumo fewtiba vuodi ifi dedwo pamopajiz imejevag pa vecudzer giondop.",
        "age": 50,
        "avatar": 1,
        "contact": "(923) 768-4872",
        "country": "Slovakia",
        "date": "20.08.2021",
        "email": "miduzog@gmail.com",
        "fatherName": "Martin Reed",
        "firstName": "Brett",
        "gender": "Male",
        "id": 46,
        "lastName": "Baccani",
        "location": "1128 Hicnin Plaza, Bercucu, Mali - 03362",
        "name": "Brett Baccani",
        "orderStatus": 2,
        "orders": 9649,
        "progress": 36,
        "role": "Accountant",
        "skills": [
            "Mobile App",
            "Web App",
            "UX",
            "Javascript"
        ],
        "status": 3,
        "time": [
            "just now"
        ]
    },
    {
        "about": "Tu pi kijbab vajwa focmap weiho pi ve elezala wifoli wic zefuh jav biecu itwukro bohgib.",
        "age": 34,
        "avatar": 9,
        "contact": "(366) 404-2200",
        "country": "Malawi",
        "date": "29.05.2021",
        "email": "zug@gmail.com",
        "fatherName": "Brent Franklin",
        "firstName": "Ollie",
        "gender": "Male",
        "id": 47,
        "lastName": "Groen",
        "location": "1992 Fesfi Avenue, Ukemopi, Faroe Islands - 07611",
        "name": "Ollie Groen",
        "orderStatus": "Cancelled",
        "orders": 159,
        "progress": 65,
        "role": "Warehouse Manager",
        "skills": [
            "UX",
            "HTML",
            "ES6"
        ],
        "status": 3,
        "time": [
            "3 hours ago"
        ]
    },
    {
        "about": "Hu lufoc rerjedte pec wecvi iwmevul ojimne fezvuw ufforkum nogeniw izu pucuhafa hidedru ferapoud rogofo.",
        "age": 52,
        "avatar": 7,
        "contact": "(480) 513-9266",
        "country": "Antarctica",
        "date": "13.04.2021",
        "email": "eniwimju@gmail.com",
        "fatherName": "George Peters",
        "firstName": "Flora",
        "gender": "Female",
        "id": 48,
        "lastName": "Parri",
        "location": "156 Hidda Glen, Tajukhi, Bangladesh - 10709",
        "name": "Flora Parri",
        "orderStatus": "Processing",
        "orders": 4092,
        "progress": 64,
        "role": "Airline Pilot",
        "skills": [
            "UX",
            "Wireframing",
            "Mobile App",
            "UI Design",
            "HTML",
            "Javascript"
        ],
        "status": 3,
        "time": [
            "1 year ago"
        ]
    },
    {
        "about": "Ga uveca ca paddozo iw zivo hus beniwroz ufgibjaz fadubok golero zet cez sib.",
        "age": 18,
        "avatar": 6,
        "contact": "(964) 293-9286",
        "country": "Congo - Brazzaville",
        "date": "24.09.2019",
        "email": "goosel@gmail.com",
        "fatherName": "Herbert Carlson",
        "firstName": "Wesley",
        "gender": "Male",
        "id": 49,
        "lastName": "Guerra",
        "location": "1172 Fozwol Place, Tacovet, Dominican Republic - 34511",
        "name": "Wesley Guerra",
        "orderStatus": "Cancelled",
        "orders": 5896,
        "progress": 60,
        "role": "Preschool Management",
        "skills": [
            "Prototyping",
            "Figma"
        ],
        "status": 2,
        "time": [
            "1 year ago"
        ]
    },
    {
        "about": "Fokaf bezbosim isjuzban hac leudu bogbif ohafoam ris ide efeguvmi se sigine nektod ipsiduno secpa.",
        "age": 34,
        "avatar": 2,
        "contact": "(656) 599-1030",
        "country": "Belgium",
        "date": "11.09.2019",
        "email": "huses@gmail.com",
        "fatherName": "Don Hines",
        "firstName": "Bessie",
        "gender": "Male",
        "id": 50,
        "lastName": "Bacherini",
        "location": "1060 Suuri Boulevard, Dipgumur, Cyprus - 83364",
        "name": "Bessie Bacherini",
        "orderStatus": "Cancelled",
        "orders": 5986,
        "progress": 12,
        "role": "Computer Graphics Specialist",
        "skills": [
            "Mobile App",
            "Prototyping",
            "Figma",
            "Angular",
            "ES6"
        ],
        "status": 2,
        "time": [
            "5 months ago"
        ]
    },
    {
        "about": "Asego izpegedu uwove ere miube bujbofsi tate jostaf rorcoclaf oj nohsapiz dovod hebku denzapmam tek ibpun fazjumi acisul.",
        "age": 63,
        "avatar": 4,
        "contact": "(457) 348-4705",
        "country": "Kyrgyzstan",
        "date": "29.08.2019",
        "email": "nizcanu@gmail.com",
        "fatherName": "Violet Briggs",
        "firstName": "Gabriel",
        "gender": "Male",
        "id": 51,
        "lastName": "Green",
        "location": "499 Olcev Pass, Kejkubim, Vietnam - 65529",
        "name": "Gabriel Green",
        "orderStatus": 2,
        "orders": 6116,
        "progress": 52,
        "role": "Security Consultant",
        "skills": [
            "Wireframing",
            "Web App",
            "Javascript",
            "UX",
            "HTML",
            "Codeigniter"
        ],
        "status": 1,
        "time": [
            "1 hour ago"
        ]
    },
    {
        "about": "Irohuviju da viddic zevzil rip zijcev ihoeh uwebotke caljaz fi fusudok wepbec.",
        "age": 39,
        "avatar": 10,
        "contact": "(920) 988-8560",
        "country": "Indonesia",
        "date": "29.08.2019",
        "email": "weurogon@gmail.com",
        "fatherName": "Bessie Robbins",
        "firstName": "Steve",
        "gender": "Male",
        "id": 52,
        "lastName": "Mills",
        "location": "455 Temun Loop, Wiwjovajo, Ecuador - 19949",
        "name": "Steve Mills",
        "orderStatus": "Completed",
        "orders": 9784,
        "progress": 6,
        "role": "Architect",
        "skills": [
            "UX",
            "Web App",
            "React"
        ],
        "status": 1,
        "time": [
            "just now"
        ]
    },
    {
        "about": "Seuciha zilso rerubbup tet doliwu aforeca kirjuh denaj ideinoefu diho ji cubrep ijovog hejniabi ravlig kim.",
        "age": 37,
        "avatar": 8,
        "contact": "(806) 799-6043",
        "country": "Macau SAR China",
        "date": "8.08.2019",
        "email": "potekod@gmail.com",
        "fatherName": "Mabel Alexander",
        "firstName": "Ricky",
        "gender": "Male",
        "id": 53,
        "lastName": "White",
        "location": "1691 Poac Extension, Zukogfe, Gibraltar - 49881",
        "name": "Ricky White",
        "orderStatus": "Processing",
        "orders": 8033,
        "progress": 48,
        "role": "Construction Manager",
        "skills": [
            "Angular",
            "Mobile App",
            "UI Design",
            "Figma",
            "Javascript",
            "ES6"
        ],
        "status": 1,
        "time": [
            "1 year ago"
        ]
    },
    {
        "about": "Kasep fadvuic tedhesof akocuf cato vuc in ilewakir keg tevonu rujadure tu.",
        "age": 62,
        "avatar": 2,
        "contact": "(706) 374-3634",
        "country": "U.S. Outlying Islands",
        "date": "16.07.2019",
        "email": "ebvovgos@gmail.com",
        "fatherName": "Donald Curry",
        "firstName": "Olive",
        "gender": "Male",
        "id": 54,
        "lastName": "Franke",
        "location": "1176 Wilif Turnpike, Wilbolo, Qatar - 25381",
        "name": "Olive Franke",
        "orderStatus": "Processing",
        "orders": 1526,
        "progress": 82,
        "role": "Industrial Designer",
        "skills": [
            "Wireframing",
            "ES6"
        ],
        "status": 1,
        "time": [
            "5 months ago"
        ]
    },
    {
        "about": "Rulido worcula wemzewro hepzev pati wuskuube igokakmo muzsuzpa za kif sef ficivis bab sogdasak hun li sugazof.",
        "age": 26,
        "avatar": 2,
        "contact": "(351) 664-8461",
        "country": "Turkey",
        "date": "25.06.2019",
        "email": "worud@gmail.com",
        "fatherName": "Marie Wise",
        "firstName": "Russell",
        "gender": "Female",
        "id": 55,
        "lastName": "Holden",
        "location": "1358 Gerag Highway, Hesuove, Sint Maarten - 56448",
        "name": "Russell Holden",
        "orderStatus": "Shipped",
        "orders": 6745,
        "progress": 64,
        "role": "Office Manager",
        "skills": [
            "Javascript",
            "Web App",
            "Backend",
            "Prototyping",
            "Codeigniter"
        ],
        "status": 3,
        "time": [
            "1 week ago"
        ]
    },
    {
        "about": "Pon ri hog zivabu kahibis dan opkeon ike hejkop durdesed edu jiza so juoze.",
        "age": 28,
        "avatar": 3,
        "contact": "(935) 927-1077",
        "country": "Portugal",
        "date": "12.06.2019",
        "email": "dehsivi@gmail.com",
        "fatherName": "Sylvia Barnett",
        "firstName": "Marian",
        "gender": "Male",
        "id": 56,
        "lastName": "Roberts",
        "location": "135 Mabih Square, Matujob, Suriname - 29434",
        "name": "Marian Roberts",
        "orderStatus": "Delivered",
        "orders": 9538,
        "progress": 85,
        "role": "Photographer",
        "skills": [
            "Codeigniter",
            "Backend"
        ],
        "status": 2,
        "time": [
            "just now"
        ]
    },
    {
        "about": "Da fac opu cut tujeko oknoose nowur duar lazdagpuh nefukga hemiwad maji jauj asipi gac.",
        "age": 18,
        "avatar": 3,
        "contact": "(942) 791-3041",
        "country": "North Korea",
        "date": "1.06.2019",
        "email": "la@gmail.com",
        "fatherName": "Eula Bass",
        "firstName": "Susan",
        "gender": "Female",
        "id": 57,
        "lastName": "Mart\u00ednez",
        "location": "996 Osaah Plaza, Wenfufagi, Spain - 67472",
        "name": "Susan Mart\u00ednez",
        "orderStatus": "Processing",
        "orders": 3692,
        "progress": 77,
        "role": "Chief Medical Officer",
        "skills": [
            "Angular",
            "UI Design",
            "Mobile App",
            "Figma"
        ],
        "status": 1,
        "time": [
            "1 week ago"
        ]
    },
    {
        "about": "Bocedzig sidit oruusewa lizforpam zaum uzficat gafuhte tubceczo cazeci tiguza cawzufuw hadagu nadgogzow.",
        "age": 20,
        "avatar": 7,
        "contact": "(471) 333-7512",
        "country": "Cura\u00e7ao",
        "date": "21.05.2019",
        "email": "ji@gmail.com",
        "fatherName": "Kyle Norman",
        "firstName": "Caleb",
        "gender": "Female",
        "id": 58,
        "lastName": "Hu",
        "location": "1311 Roewu Point, Tocacaro, Mozambique - 01604",
        "name": "Caleb Hu",
        "orderStatus": "Delivered",
        "orders": 4065,
        "progress": 14,
        "role": "Speech Pathologist",
        "skills": [
            "Javascript",
            "Figma"
        ],
        "status": 2,
        "time": [
            "just now"
        ]
    },
    {
        "about": "Pi apuciptug ludpa uza vififan cem vez livkut goizi nip totu na ka.",
        "age": 42,
        "avatar": 6,
        "contact": "(523) 511-2371",
        "country": "Guinea-Bissau",
        "date": "15.05.2019",
        "email": "edamomi@gmail.com",
        "fatherName": "Sallie Williamson",
        "firstName": "Noah",
        "gender": "Female",
        "id": 59,
        "lastName": "West",
        "location": "428 Kugves Grove, Vulefuj, Oman - 38069",
        "name": "Noah West",
        "orderStatus": 2,
        "orders": 4782,
        "progress": 2,
        "role": "Graphic Designer",
        "skills": [
            "UX",
            "ES6",
            "Codeigniter",
            "Prototyping"
        ],
        "status": 1,
        "time": [
            "5 months ago"
        ]
    },
    {
        "about": "Izineka afuwefim lowijuf lu caccasso ukoco lovoka fuwabi ilholero finuof ijzoigi ul ud se sahej rafzimas kavwopet gugva.",
        "age": 33,
        "avatar": 9,
        "contact": "(968) 630-9699",
        "country": "Macedonia",
        "date": "26.04.2019",
        "email": "det@gmail.com",
        "fatherName": "Peter Diaz",
        "firstName": "Maude",
        "gender": "Female",
        "id": 60,
        "lastName": "Kool",
        "location": "80 Dakciv Square, Gahakwu, Lithuania - 12481",
        "name": "Maude Kool",
        "orderStatus": "Shipped",
        "orders": 5465,
        "progress": 53,
        "role": "Direct Marketer",
        "skills": [
            "React",
            "Codeigniter",
            "Figma",
            "Prototyping",
            "Web App"
        ],
        "status": 1,
        "time": [
            "1 day ago"
        ]
    },
    {
        "about": "Of magde jo naliaz gawofiv toz ow rapojri inapib vaha eloc lo ruojifo catavu.",
        "age": 62,
        "avatar": 9,
        "contact": "(861) 957-5361",
        "country": "Sweden",
        "date": "9.04.2019",
        "email": "bur@gmail.com",
        "fatherName": "Dollie Atkins",
        "firstName": "Danny",
        "gender": "Female",
        "id": 61,
        "lastName": "Vink",
        "location": "1473 Fapfop View, Bolfuknav, Albania - 85753",
        "name": "Danny Vink",
        "orderStatus": 2,
        "orders": 432,
        "progress": 3,
        "role": "Title Examiner",
        "skills": [
            "Angular",
            "Wireframing",
            "Backend"
        ],
        "status": 1,
        "time": [
            "1 year ago"
        ]
    },
    {
        "about": "Vi iplok vucegop cuznorzon do icco zilduh kanivif he mojas bi tegik ufiwit imeaffub bifeagi lobajla tek amehopa.",
        "age": 47,
        "avatar": 4,
        "contact": "(320) 697-7303",
        "country": "Chad",
        "date": "5.04.2019",
        "email": "leteluf@gmail.com",
        "fatherName": "Edward Mathis",
        "firstName": "Jared",
        "gender": "Male",
        "id": 62,
        "lastName": "Humphries",
        "location": "1314 Weler Trail, Upbotdi, Niger - 46496",
        "name": "Jared Humphries",
        "orderStatus": "Shipped",
        "orders": 1341,
        "progress": 36,
        "role": "Athletic Coach",
        "skills": [
            "ES6",
            "Codeigniter",
            "Angular",
            "Mobile App",
            "Backend"
        ],
        "status": 2,
        "time": [
            "1 week ago"
        ]
    },
    {
        "about": "Tuhe femel niocnin wisetiri ra cegit pevsate benepa fo dokmetvaf keg mob kuba datac acuopapaw nujose.",
        "age": 19,
        "avatar": 7,
        "contact": "(607) 209-3055",
        "country": "Mauritania",
        "date": "23.03.2019",
        "email": "isu@gmail.com",
        "fatherName": "Manuel Figueroa",
        "firstName": "Chad",
        "gender": "Female",
        "id": 63,
        "lastName": "Richard",
        "location": "1737 Vedij Ridge, Paalvad, Mauritius - 40821",
        "name": "Chad Richard",
        "orderStatus": "Completed",
        "orders": 3148,
        "progress": 96,
        "role": "Financier",
        "skills": [
            "Web App",
            "Backend",
            "Javascript",
            "ES6",
            "Prototyping",
            "UI Design"
        ],
        "status": 3,
        "time": [
            "1 day ago"
        ]
    },
    {
        "about": "Reovi cobdo vu vac kimtubaso unovokgu tihoznat agtuko dow so vu fud jadfoan vovu sevatim nomgavbuv apufok larhi.",
        "age": 18,
        "avatar": 4,
        "contact": "(322) 670-3985",
        "country": "Jamaica",
        "date": "17.03.2019",
        "email": "nanfe@gmail.com",
        "fatherName": "Cole Wells",
        "firstName": "Della",
        "gender": "Female",
        "id": 64,
        "lastName": "Rivi\u00e8re",
        "location": "1570 Ofowe Trail, Agboeci, Samoa - 95273",
        "name": "Della Rivi\u00e8re",
        "orderStatus": 2,
        "orders": 8694,
        "progress": 46,
        "role": "Lawyer",
        "skills": [
            "Backend",
            "ES6",
            "UI Design"
        ],
        "status": 1,
        "time": [
            "1 day ago"
        ]
    },
    {
        "about": "Bu fofci juwjipfar idozug ca sinu mel zohba ipokajat jig giipiwa wig noziz tev vawhitlec davrimac ligca cefzegloc.",
        "age": 45,
        "avatar": 7,
        "contact": "(548) 697-4695",
        "country": "Guinea-Bissau",
        "date": "20.03.2019",
        "email": "tefluopa@gmail.com",
        "fatherName": "Elmer Ray",
        "firstName": "Jayden",
        "gender": "Female",
        "id": 65,
        "lastName": "L\u00e9ger",
        "location": "109 Huwmum Court, Mehsakpi, Mozambique - 74034",
        "name": "Jayden L\u00e9ger",
        "orderStatus": "Shipped",
        "orders": 9526,
        "progress": 78,
        "role": "Construction Engineer",
        "skills": [
            "React",
            "UI Design"
        ],
        "status": 3,
        "time": [
            "1 day ago"
        ]
    },
    {
        "about": "Sak giporis pas nodzu ibjo lulcapte deneb sus bag wiwopwu osemima rettazo medabfit baoko piw uhese meseskek goc.",
        "age": 43,
        "avatar": 1,
        "contact": "(740) 205-4505",
        "country": "Austria",
        "date": "17.03.2019",
        "email": "na@gmail.com",
        "fatherName": "Evan Gonzalez",
        "firstName": "Jacob",
        "gender": "Female",
        "id": 66,
        "lastName": "Vannini",
        "location": "479 Enbo Pass, Hufacuv, Indonesia - 02070",
        "name": "Jacob Vannini",
        "orderStatus": 2,
        "orders": 1860,
        "progress": 55,
        "role": "Consumer Relations Manager",
        "skills": [
            "Figma",
            "Angular",
            "Wireframing",
            "Javascript"
        ],
        "status": 1,
        "time": [
            "1 day ago"
        ]
    },
    {
        "about": "Cabibji izta tasmufe binlanen kefsino kazva ozkajej ihonej ba niv ri ohohatmif wihipgu wevove coiru.",
        "age": 20,
        "avatar": 7,
        "contact": "(753) 360-5730",
        "country": "Guam",
        "date": "10.03.2019",
        "email": "ru@gmail.com",
        "fatherName": "Jeffrey Gibbs",
        "firstName": "Jesus",
        "gender": "Male",
        "id": 67,
        "lastName": "Nuti",
        "location": "876 Ajez Court, Boluztip, American Samoa - 06860",
        "name": "Jesus Nuti",
        "orderStatus": "Shipped",
        "orders": 6589,
        "progress": 48,
        "role": "General Counsel",
        "skills": [
            "Prototyping",
            "UI Design",
            "Figma",
            "Backend"
        ],
        "status": 3,
        "time": [
            "2 min ago"
        ]
    },
    {
        "about": "Fibombuw etroep wov hoiv kuemmu fejke hurbavu tavur zevamatir ojicowipi wefbuv lorezome hedossok farazwuz wanbolwoz jik ezojuzon.",
        "age": 61,
        "avatar": 3,
        "contact": "(548) 536-9235",
        "country": "Sudan",
        "date": "28.02.2019",
        "email": "pifjif@gmail.com",
        "fatherName": "Marcus Stevenson",
        "firstName": "Mike",
        "gender": "Male",
        "id": 68,
        "lastName": "Forti",
        "location": "1576 Webbam Parkway, Vototdu, Czech Republic - 77664",
        "name": "Mike Forti",
        "orderStatus": "Refunded",
        "orders": 4611,
        "progress": 21,
        "role": "Construction Engineer",
        "skills": [
            "Figma",
            "Angular",
            "Web App"
        ],
        "status": 3,
        "time": [
            "5 months ago"
        ]
    },
    {
        "about": "Minence mukeg nabikahut bufushih ijda opianuned zosiru ohzufhon vuv etoadiruk ubikiga efjus wijep soggotag izutaori anoji ab.",
        "age": 25,
        "avatar": 6,
        "contact": "(384) 497-7706",
        "country": "China",
        "date": "27.02.2019",
        "email": "fa@gmail.com",
        "fatherName": "Nancy Armstrong",
        "firstName": "Nicholas",
        "gender": "Male",
        "id": 69,
        "lastName": "Baumann",
        "location": "1423 Vuwpu Street, Tilkocoj, Thailand - 83166",
        "name": "Nicholas Baumann",
        "orderStatus": 2,
        "orders": 1783,
        "progress": 12,
        "role": "Health Care Manager",
        "skills": [
            "Wireframing",
            "ES6",
            "UX",
            "HTML",
            "React"
        ],
        "status": 2,
        "time": [
            "1 hour ago"
        ]
    },
    {
        "about": "Zu sasep sesor hoav lu tazaca za nob umwe lal leew se ce du ag titwu bu iseid.",
        "age": 54,
        "avatar": 2,
        "contact": "(426) 362-5099",
        "country": "C\u00f4te d'Ivoire",
        "date": "13.02.2019",
        "email": "emijahig@gmail.com",
        "fatherName": "Jack Reese",
        "firstName": "Marvin",
        "gender": "Male",
        "id": 70,
        "lastName": "Bell",
        "location": "1706 Jisu Circle, Otjursiv, Colombia - 96931",
        "name": "Marvin Bell",
        "orderStatus": "Refunded",
        "orders": 4971,
        "progress": 84,
        "role": "Actor",
        "skills": [
            "Figma",
            "Angular"
        ],
        "status": 2,
        "time": [
            "just now"
        ]
    },
    {
        "about": "Zijar cupife tiffiidi ju zadomifod zi zojhot jewe wilowju mum ofi runib nevacgum.",
        "age": 53,
        "avatar": 1,
        "contact": "(936) 315-7811",
        "country": "Venezuela",
        "date": "31.01.2019",
        "email": "vosela@gmail.com",
        "fatherName": "Michael Bass",
        "firstName": "Ada",
        "gender": "Female",
        "id": 71,
        "lastName": "Merino",
        "location": "279 Malcaz Point, Izsafci, Ascension Island - 87585",
        "name": "Ada Merino",
        "orderStatus": "Cancelled",
        "orders": 2602,
        "progress": 79,
        "role": "IT Architect",
        "skills": [
            "Javascript",
            "ES6",
            "UX",
            "Mobile App"
        ],
        "status": 3,
        "time": [
            "3 hours ago"
        ]
    },
    {
        "about": "Okefi vuhce mezo bacjucga lidlipti no wozalga culat suubuze acatufe ve epegu vubtowjin.",
        "age": 18,
        "avatar": 7,
        "contact": "(527) 712-2968",
        "country": "Trinidad & Tobago",
        "date": "19.01.2019",
        "email": "opadegdec@gmail.com",
        "fatherName": "Curtis Caldwell",
        "firstName": "Calvin",
        "gender": "Male",
        "id": 72,
        "lastName": "Celli",
        "location": "1691 Jebut Path, Rebnumo, Guam - 00171",
        "name": "Calvin Celli",
        "orderStatus": "Processing",
        "orders": 5614,
        "progress": 21,
        "role": "Environmental Attorney",
        "skills": [
            "HTML",
            "Mobile App",
            "Backend",
            "UI Design",
            "Prototyping",
            "ES6"
        ],
        "status": 3,
        "time": [
            "just now"
        ]
    },
    {
        "about": "Ihwefif le vu jada fewebziw ritujcup daemo popubbe leca hefpi pem cosep kif humba punus arco kocici ehbo.",
        "age": 62,
        "avatar": 1,
        "contact": "(669) 731-5429",
        "country": "Mongolia",
        "date": "03.01.2019",
        "email": "kiescar@gmail.com",
        "fatherName": "Barbara Luna",
        "firstName": "Nettie",
        "gender": "Male",
        "id": 73,
        "lastName": "Hopkins",
        "location": "1754 Kewle Manor, Dohehluw, Cocos (Keeling) Islands - 53115",
        "name": "Nettie Hopkins",
        "orderStatus": "Delivered",
        "orders": 4114,
        "progress": 98,
        "role": "Medical Secretary",
        "skills": [
            "Mobile App",
            "Web App"
        ],
        "status": 2,
        "time": [
            "1 hour ago"
        ]
    },
    {
        "about": "Uv lirimi mev apto sueru mana hos woplujus fuk wehsi es tid agkiz zap ajrig.",
        "age": 19,
        "avatar": 4,
        "contact": "(930) 420-5183",
        "country": "Qatar",
        "date": "03.01.2019",
        "email": "zenconwev@gmail.com",
        "fatherName": "Katherine Craig",
        "firstName": "Lee",
        "gender": "Male",
        "id": 74,
        "lastName": "Piani",
        "location": "748 Fuwbi Loop, Ecimeviro, Falkland Islands - 71060",
        "name": "Lee Piani",
        "orderStatus": "Shipped",
        "orders": 6601,
        "progress": 1,
        "role": "Entrepreneur",
        "skills": [
            "React",
            "Figma",
            "Javascript",
            "UX",
            "Codeigniter"
        ],
        "status": 2,
        "time": [
            "2 days ago"
        ]
    },
    {
        "about": "Ho kigeodi wuvuppo tumkir unpofij wukzi co mon itoret buag azebfa og.",
        "age": 19,
        "avatar": 3,
        "contact": "(515) 705-1083",
        "country": "Marshall Islands",
        "date": "30.12.2018",
        "email": "onupo@gmail.com",
        "fatherName": "Francis Sparks",
        "firstName": "Johanna",
        "gender": "Male",
        "id": 75,
        "lastName": "Perez",
        "location": "46 Liwon Trail, Relemuaz, Trinidad & Tobago - 33861",
        "name": "Johanna Perez",
        "orderStatus": "Completed",
        "orders": 3801,
        "progress": 55,
        "role": "Public Administrator",
        "skills": [
            "Wireframing",
            "Backend",
            "UI Design"
        ],
        "status": 2,
        "time": [
            "1 day ago"
        ]
    },
    {
        "about": "Hebeh firseuc go tozuzim cope pukgaha kuufhet bonluvhe be evreido towjipu ku kodir.",
        "age": 58,
        "avatar": 9,
        "contact": "(207) 899-6281",
        "country": "Kyrgyzstan",
        "date": "24.12.2018",
        "email": "na@gmail.com",
        "fatherName": "Kenneth Swanson",
        "firstName": "Claudia",
        "gender": "Male",
        "id": 76,
        "lastName": "Rizzo",
        "location": "1946 Foppig Loop, Vujofwo, Cambodia - 76417",
        "name": "Claudia Rizzo",
        "orderStatus": 2,
        "orders": 5548,
        "progress": 59,
        "role": "Account Executive",
        "skills": [
            "UX",
            "UI Design",
            "Figma"
        ],
        "status": 1,
        "time": [
            "1 day ago"
        ]
    },
    {
        "about": "Jasku za po ifhom ud wodoud zariwi itru imu bubli lukali uw niup rogu bace bomi.",
        "age": 35,
        "avatar": 4,
        "contact": "(378) 272-9824",
        "country": "New Caledonia",
        "date": "17.12.2018",
        "email": "aw@gmail.com",
        "fatherName": "Alma Bates",
        "firstName": "Daisy",
        "gender": "Male",
        "id": 77,
        "lastName": "Crini",
        "location": "1711 Arode Ridge, Akepni, St. Vincent & Grenadines - 47211",
        "name": "Daisy Crini",
        "orderStatus": "Dispatched",
        "orders": 3534,
        "progress": 20,
        "role": "Franchise Management",
        "skills": [
            "Codeigniter",
            "Web App",
            "Figma",
            "UX",
            "Wireframing"
        ],
        "status": 2,
        "time": [
            "1 year ago"
        ]
    },
    {
        "about": "Mutokhuk cogdohmon gios ronragwa vo tuskega ni pe koen zadzaftir od guktusret bo calibado redmojoce luj.",
        "age": 63,
        "avatar": 3,
        "contact": "(810) 245-7941",
        "country": "Grenada",
        "date": "09.12.2018",
        "email": "beba@gmail.com",
        "fatherName": "Frederick Dixon",
        "firstName": "Clayton",
        "gender": "Male",
        "id": 78,
        "lastName": "Brown",
        "location": "511 Papac Trail, Pupkinuz, Mongolia - 70630",
        "name": "Clayton Brown",
        "orderStatus": "Shipped",
        "orders": 5171,
        "progress": 74,
        "role": "Comptroller",
        "skills": [
            "Web App",
            "UI Design",
            "HTML",
            "Prototyping",
            "Javascript"
        ],
        "status": 1,
        "time": [
            "2 days ago"
        ]
    },
    {
        "about": "Ve kigulaag wa burcuwo za na et li niv itatij ujogdun lecimas dejme.",
        "age": 35,
        "avatar": 9,
        "contact": "(800) 687-5069",
        "country": "Antigua & Barbuda",
        "date": "03.12.2018",
        "email": "gutuzne@gmail.com",
        "fatherName": "Hunter Ingram",
        "firstName": "Rodney",
        "gender": "Male",
        "id": 79,
        "lastName": "Bandinelli",
        "location": "1529 Pelu Square, Zepkihrok, Zimbabwe - 91141",
        "name": "Rodney Bandinelli",
        "orderStatus": "Refunded",
        "orders": 4170,
        "progress": 92,
        "role": "Artist",
        "skills": [
            "Javascript",
            "HTML"
        ],
        "status": 1,
        "time": [
            "just now"
        ]
    },
    {
        "about": "Loit nih zadul wokazu ta eno pigzuziz ruwulmid divkumas wehumjuv zu pew erasis gaba ofa fenucfo.",
        "age": 65,
        "avatar": 6,
        "contact": "(306) 760-5777",
        "country": "Poland",
        "date": "28.11.2018",
        "email": "daev@gmail.com",
        "fatherName": "Leroy Steele",
        "firstName": "Danny",
        "gender": "Male",
        "id": 80,
        "lastName": "Tomlinson",
        "location": "1639 Jajteb Manor, Ojtokriw, Myanmar (Burma) - 38413",
        "name": "Danny Tomlinson",
        "orderStatus": "Completed",
        "orders": 7427,
        "progress": 16,
        "role": "Mathematician",
        "skills": [
            "ES6",
            "Web App",
            "Prototyping",
            "Javascript",
            "React",
            "HTML"
        ],
        "status": 1,
        "time": [
            "2 days ago"
        ]
    },
    {
        "about": "Te ahuge igevuk dog kesuw jabuv nabal zurop eru firvajez kek leba evpeg empi bejgo fejniz webpodjop.",
        "age": 37,
        "avatar": 1,
        "contact": "(636) 744-2766",
        "country": "Cameroon",
        "date": "23.11.2018",
        "email": "osidiwdo@gmail.com",
        "fatherName": "Carrie Black",
        "firstName": "Cordelia",
        "gender": "Male",
        "id": 81,
        "lastName": "Cecchini",
        "location": "182 Bafo Pike, Surucro, Germany - 65802",
        "name": "Cordelia Cecchini",
        "orderStatus": "Dispatched",
        "orders": 3317,
        "progress": 47,
        "role": "Trainer Translator",
        "skills": [
            "Prototyping",
            "Backend",
            "UX",
            "ES6",
            "HTML"
        ],
        "status": 1,
        "time": [
            "5 months ago"
        ]
    },
    {
        "about": "Uliva jedme ka ulho revir dino cizsus cipec afisihi vazbofga bepacsev gemkeza relwo bico api.",
        "age": 52,
        "avatar": 1,
        "contact": "(435) 899-5670",
        "country": "Libya",
        "date": "19.11.2018",
        "email": "figle@gmail.com",
        "fatherName": "Luke Jacobs",
        "firstName": "Agnes",
        "gender": "Male",
        "id": 82,
        "lastName": "Griffin",
        "location": "522 Ipha Manor, Jazijdis, Malta - 25254",
        "name": "Agnes Griffin",
        "orderStatus": 2,
        "orders": 612,
        "progress": 89,
        "role": "Legal Secretary",
        "skills": [
            "Prototyping",
            "UI Design",
            "React"
        ],
        "status": 1,
        "time": [
            "1 year ago"
        ]
    },
    {
        "about": "Obiju til dimu evuegijij useze ce vozarbep bohgein putep biw lezisege buwu hes su nuefi wezpe odjelfim ew.",
        "age": 29,
        "avatar": 10,
        "contact": "(813) 693-6185",
        "country": "Kiribati",
        "date": "11.11.2018",
        "email": "ripapbef@gmail.com",
        "fatherName": "Micheal Murphy",
        "firstName": "Andrew",
        "gender": "Male",
        "id": 83,
        "lastName": "Payne",
        "location": "458 Feviw Center, Wamibis, Falkland Islands - 12047",
        "name": "Andrew Payne",
        "orderStatus": "Processing",
        "orders": 7370,
        "progress": 31,
        "role": "Strategic Planning Director",
        "skills": [
            "Angular",
            "Mobile App",
            "Web App",
            "React",
            "UX",
            "Prototyping"
        ],
        "status": 3,
        "time": [
            "3 hours ago"
        ]
    },
    {
        "about": "Bajvajaj tijpam ped ofo ifjuva panu ocavuv levec ma limiigo sicnuve rasuv ridjoz et hibhom wuko ze.",
        "age": 39,
        "avatar": 6,
        "contact": "(641) 445-7986",
        "country": "Zimbabwe",
        "date": "06.11.2018",
        "email": "zisgiomi@gmail.com",
        "fatherName": "Arthur Allen",
        "firstName": "Jason",
        "gender": "Female",
        "id": 84,
        "lastName": "Smeets",
        "location": "1407 Lahije Road, Vujibu, Rwanda - 19747",
        "name": "Jason Smeets",
        "orderStatus": "Dispatched",
        "orders": 5628,
        "progress": 62,
        "role": "Sales Engineer",
        "skills": [
            "Javascript",
            "Mobile App",
            "React",
            "HTML"
        ],
        "status": 2,
        "time": [
            "2 min ago"
        ]
    },
    {
        "about": "Sotsoru ek daom cobol ho usdow wikuk pav so fawidwuv il cupsona ajofi awpodlag rit otiko talen.",
        "age": 21,
        "avatar": 3,
        "contact": "(644) 309-5163",
        "country": "Haiti",
        "date": "29.10.2018",
        "email": "cukgafhi@gmail.com",
        "fatherName": "Herbert Hernandez",
        "firstName": "Johanna",
        "gender": "Male",
        "id": 85,
        "lastName": "Fletcher",
        "location": "306 Bubog Highway, Ijpikos, Djibouti - 26040",
        "name": "Johanna Fletcher",
        "orderStatus": "Dispatched",
        "orders": 2469,
        "progress": 80,
        "role": "Data Security Manager",
        "skills": [
            "Backend",
            "Mobile App",
            "Wireframing"
        ],
        "status": 1,
        "time": [
            "2 days ago"
        ]
    },
    {
        "about": "Ripdi fozof al wionodo gur rojge mirpe fosnalci tedle vuvebvam becazione tu ci kagu fubaga gam cezoruziz.",
        "age": 64,
        "avatar": 4,
        "contact": "(662) 534-4890",
        "country": "Isle of Man",
        "date": "22.10.2018",
        "email": "jupucih@gmail.com",
        "fatherName": "Aaron Tate",
        "firstName": "Jorge",
        "gender": "Male",
        "id": 86,
        "lastName": "Pesci",
        "location": "1143 Nustep Avenue, Saojifo, Panama - 86633",
        "name": "Jorge Pesci",
        "orderStatus": "Cancelled",
        "orders": 4641,
        "progress": 24,
        "role": "Sanitation Engineer",
        "skills": [
            "Web App",
            "Codeigniter"
        ],
        "status": 2,
        "time": [
            "2 days ago"
        ]
    },
    {
        "about": "Uz levbumud ne gorrarlol cizcasos zag kisenca rirguuz gu suzamuz haivu divov derinis beg so fipib suvijmir mewnoebu.",
        "age": 25,
        "avatar": 3,
        "contact": "(446) 676-7574",
        "country": "Colombia",
        "date": "19.10.2018",
        "email": "jef@gmail.com",
        "fatherName": "Minnie Webster",
        "firstName": "Raymond",
        "gender": "Male",
        "id": 87,
        "lastName": "Picchi",
        "location": "352 Zidiha Circle, Avoosaos, Seychelles - 17289",
        "name": "Raymond Picchi",
        "orderStatus": "Refunded",
        "orders": 9035,
        "progress": 56,
        "role": "Lab Technician",
        "skills": [
            "Wireframing",
            "UI Design",
            "Codeigniter"
        ],
        "status": 1,
        "time": [
            "3 hours ago"
        ]
    },
    {
        "about": "Kodire nut ubucusug mitriti sam fahebruf ij azge kavcuja no hidzemca guvrike.",
        "age": 20,
        "avatar": 9,
        "contact": "(305) 691-7595",
        "country": "Venezuela",
        "date": "11.10.2018",
        "email": "sinulan@gmail.com",
        "fatherName": "Anthony Nichols",
        "firstName": "Rosie",
        "gender": "Female",
        "id": 88,
        "lastName": "Chiarugi",
        "location": "1368 Kutcu Manor, Vupdutej, Ecuador - 22677",
        "name": "Rosie Chiarugi",
        "orderStatus": "Delivered",
        "orders": 2636,
        "progress": 3,
        "role": "Political Analyst",
        "skills": [
            "Wireframing",
            "React",
            "Web App",
            "UX"
        ],
        "status": 2,
        "time": [
            "just now"
        ]
    },
    {
        "about": "Lozoic guwuog bespom zipavu min agvagzac ifefa awa rize hob afgih ufapubek.",
        "age": 44,
        "avatar": 4,
        "contact": "(313) 960-3849",
        "country": "United Arab Emirates",
        "date": "06.10.2018",
        "email": "woefsoz@gmail.com",
        "fatherName": "Alberta Simon",
        "firstName": "Norman",
        "gender": "Female",
        "id": 89,
        "lastName": "Slater",
        "location": "51 Wiop Key, Biedki, Slovakia - 93112",
        "name": "Norman Slater",
        "orderStatus": "Processing",
        "orders": 2588,
        "progress": 62,
        "role": "PR Specialist",
        "skills": [
            "Backend",
            "Angular"
        ],
        "status": 3,
        "time": [
            "1 day ago"
        ]
    },
    {
        "about": "Ajulecsi hewow lupad hib jewa bu lid bamella hiw haded tumi tidjo.",
        "age": 23,
        "avatar": 7,
        "contact": "(653) 953-7893",
        "country": "Thailand",
        "date": "27.09.2018",
        "email": "pelcecov@gmail.com",
        "fatherName": "Dominic Porter",
        "firstName": "Julian",
        "gender": "Female",
        "id": 90,
        "lastName": "Schipper",
        "location": "569 Kitpi Center, Sefimama, Turkey - 12220",
        "name": "Julian Schipper",
        "orderStatus": "Delivered",
        "orders": 7713,
        "progress": 87,
        "role": "Marketing Director",
        "skills": [
            "Web App",
            "Javascript"
        ],
        "status": 2,
        "time": [
            "3 hours ago"
        ]
    },
    {
        "about": "Ta fe fodsus vapdemi veglafun pultepo zifoz pihpap ku awofot meceta elako.",
        "age": 43,
        "avatar": 8,
        "contact": "(528) 422-1481",
        "country": "Chile",
        "date": "15.09.2018",
        "email": "tacevmi@gmail.com",
        "fatherName": "Gavin Stevens",
        "firstName": "Gavin",
        "gender": "Female",
        "id": 91,
        "lastName": "Panichi",
        "location": "1342 Konag Parkway, Ohufema, Georgia - 51543",
        "name": "Gavin Panichi",
        "orderStatus": "Cancelled",
        "orders": 2933,
        "progress": 1,
        "role": "Process Engineer",
        "skills": [
            "React",
            "HTML",
            "Figma",
            "Codeigniter"
        ],
        "status": 2,
        "time": [
            "1 year ago"
        ]
    },
    {
        "about": "Hu wuifku pu mebidi ibeorase was bipnuam hace zov fure rohil ubojowza save vaval riz sezuceni fo fu.",
        "age": 19,
        "avatar": 9,
        "contact": "(853) 820-6601",
        "country": "Thailand",
        "date": "05.09.2018",
        "email": "coemet@gmail.com",
        "fatherName": "Lillian Hughes",
        "firstName": "Victor",
        "gender": "Male",
        "id": 92,
        "lastName": "Battaglini",
        "location": "706 Uzho Junction, Sumfuktob, French Guiana - 43651",
        "name": "Victor Battaglini",
        "orderStatus": 2,
        "orders": 1646,
        "progress": 27,
        "role": "Interior Decorator",
        "skills": [
            "Web App",
            "Javascript",
            "UI Design",
            "Backend",
            "Prototyping",
            "Mobile App"
        ],
        "status": 3,
        "time": [
            "1 year ago"
        ]
    },
    {
        "about": "Osewu awesapoh remi uv ki fe jucjurip su cacdup ifbizac ehki edo mowecne uv dihme wavergo mujivhon.",
        "age": 52,
        "avatar": 8,
        "contact": "(324) 919-4507",
        "country": "Switzerland",
        "date": "25.08.2018",
        "email": "hawog@gmail.com",
        "fatherName": "Leonard Cortez",
        "firstName": "Miguel",
        "gender": "Female",
        "id": 93,
        "lastName": "Franceschi",
        "location": "509 Jehis Glen, Osuclad, Guam - 00483",
        "name": "Miguel Franceschi",
        "orderStatus": 2,
        "orders": 8464,
        "progress": 97,
        "role": "Business Manager",
        "skills": [
            "Figma",
            "Web App",
            "Mobile App",
            "UX",
            "UI Design"
        ],
        "status": 1,
        "time": [
            "3 hours ago"
        ]
    },
    {
        "about": "Ugdihit elunocid vocmiuda puhilca fo muuhku dekfanduz botas cu sa liki ba ra nesekna ulijevba orukalo tejdi voet.",
        "age": 34,
        "avatar": 10,
        "contact": "(976) 570-4442",
        "country": "Malta",
        "date": "18.08.2018",
        "email": "zu@gmail.com",
        "fatherName": "Christina Bennett",
        "firstName": "Jeffrey",
        "gender": "Male",
        "id": 94,
        "lastName": "Sanchez",
        "location": "1698 Zoda Circle, Abekamu, Guam - 47112",
        "name": "Jeffrey Sanchez",
        "orderStatus": 2,
        "orders": 5029,
        "progress": 61,
        "role": "Estimator",
        "skills": [
            "Web App",
            "UI Design",
            "ES6",
            "Backend",
            "Javascript"
        ],
        "status": 1,
        "time": [
            "1 day ago"
        ]
    },
    {
        "about": "Wenkoh nad ne obsa baluceso nuuz nac ciknicec mew ofu tolef lid mo.",
        "age": 30,
        "avatar": 3,
        "contact": "(435) 526-1990",
        "country": "Hungary",
        "date": "09.08.2018",
        "email": "vivecgu@gmail.com",
        "fatherName": "Lenora Zimmerman",
        "firstName": "Matilda",
        "gender": "Male",
        "id": 95,
        "lastName": "Hermans",
        "location": "256 Mawaw Place, Fawjanul, Qatar - 67211",
        "name": "Matilda Hermans",
        "orderStatus": 2,
        "orders": 3515,
        "progress": 51,
        "role": "Health Care Manager",
        "skills": [
            "HTML",
            "ES6"
        ],
        "status": 3,
        "time": [
            "1 day ago"
        ]
    },
    {
        "about": "Orup mebirlah lelvu zukoz naghuke tijjowbok ci ok pofni we su jozofa gu.",
        "age": 21,
        "avatar": 5,
        "contact": "(946) 725-4920",
        "country": "Bahrain",
        "date": "1.08.2018",
        "email": "sesivic@gmail.com",
        "fatherName": "John Allison",
        "firstName": "Lester",
        "gender": "Female",
        "id": 96,
        "lastName": "Palagi",
        "location": "1169 Cidroj Loop, Zazmefe, Jordan - 89413",
        "name": "Lester Palagi",
        "orderStatus": "Refunded",
        "orders": 8982,
        "progress": 13,
        "role": "Building Manager",
        "skills": [
            "Mobile App",
            "Figma",
            "HTML",
            "React",
            "Javascript"
        ],
        "status": 1,
        "time": [
            "1 week ago"
        ]
    },
    {
        "about": "So okwi li evhug cemvu kubu nughanem ufasot tausla anacu je ewuvfe ih sicno fe si owafadnom.",
        "age": 40,
        "avatar": 3,
        "contact": "(687) 252-5573",
        "country": "Ethiopia",
        "date": "28.07.2018",
        "email": "lagmekfez@gmail.com",
        "fatherName": "Sam McBride",
        "firstName": "Emilie",
        "gender": "Male",
        "id": 97,
        "lastName": "Humbert",
        "location": "1260 Uzous Parkway, Zelkevweh, Latvia - 72103",
        "name": "Emilie Humbert",
        "orderStatus": "Cancelled",
        "orders": 3760,
        "progress": 23,
        "role": "Principal",
        "skills": [
            "Javascript",
            "Figma",
            "ES6",
            "Mobile App",
            "HTML"
        ],
        "status": 3,
        "time": [
            "1 day ago"
        ]
    },
    {
        "about": "Uki bohto je ocjajas kalu pi nuci ezucidewa de aravekwap ris nizcu ag.",
        "age": 55,
        "avatar": 8,
        "contact": "(877) 405-2202",
        "country": "Nigeria",
        "date": "21.07.2018",
        "email": "ulusolzil@gmail.com",
        "fatherName": "Franklin Padilla",
        "firstName": "Lelia",
        "gender": "Male",
        "id": 98,
        "lastName": "Bianchi",
        "location": "802 Awimi Grove, Owiweburo, Russia - 01368",
        "name": "Lelia Bianchi",
        "orderStatus": "Refunded",
        "orders": 9828,
        "progress": 74,
        "role": "Nursing Administrator",
        "skills": [
            "Codeigniter",
            "React",
            "HTML"
        ],
        "status": 3,
        "time": [
            "just now"
        ]
    },
    {
        "about": "Reb pewpubac to lub zet nibura nocnatdun vah gulo jo jij inku.",
        "age": 63,
        "avatar": 6,
        "contact": "(382) 858-5995",
        "country": "Kenya",
        "date": "15.07.2018",
        "email": "ket@gmail.com",
        "fatherName": "Ernest Kennedy",
        "firstName": "Nora",
        "gender": "Male",
        "id": 99,
        "lastName": "Willis",
        "location": "691 Bifu Grove, Ihiwocij, Guyana - 53238",
        "name": "Nora Willis",
        "orderStatus": "Processing",
        "orders": 2247,
        "progress": 62,
        "role": "Grounds Keeper",
        "skills": [
            "Mobile App",
            "Figma",
            "Backend",
            "Angular",
            "HTML"
        ],
        "status": 2,
        "time": [
            "1 hour ago"
        ]
    },
    {
        "about": "Esovilzul didus muwi dezsik milabgo ewnu lizdewo mod ase elgal ezono fezjulpa bi fewob enles.",
        "age": 55,
        "avatar": 6,
        "contact": "(965) 886-4355",
        "country": "Russia",
        "date": "12.07.2018",
        "email": "sah@gmail.com",
        "fatherName": "Jeanette Fleming",
        "firstName": "Earl",
        "gender": "Female",
        "id": 100,
        "lastName": "Parrini",
        "location": "875 Nedov Highway, Gosfojik, Mayotte - 02140",
        "name": "Earl Parrini",
        "orderStatus": "Refunded",
        "orders": 9676,
        "progress": 18,
        "role": "Art Director",
        "skills": [
            "Codeigniter",
            "HTML",
            "Prototyping",
            "Mobile App",
            "Figma",
            "Angular"
        ],
        "status": 1,
        "time": [
            "1 day ago"
        ]
    }
]


export const INVOICE_LIST: InvoiceList[] = [
    {
        "avatar": 5,
        "cashierInfo": {
            "address": "1754 Ureate, RhodSA5 5BO",
            "email": "iacrpt65@gmail.com",
            "name": "Ian Carpenter",
            "phone": "+91 1234567890"
        },
        "customerInfo": {
            "address": "1300 Mine RoadQuemado, NM 87829",
            "email": "belljrc23@gmail.com",
            "name": "Belle J. Richter",
            "phone": "305-829-7809"
        },
        "customer_name": "Tessi Eneas",
        "date": "05/01/2022",
        "discount": 0.5,
        "due_date": "06/02/2022",
        "email": "tass23@gmail.com",
        "id": 1,
        "invoice_detail": [
            {
                "description": "Apple Watch SE Smartwatch",
                "id": 2,
                "name": "Apple Series 4 GPS A38 MM Space",
                "price": 275,
                "qty": 3
            },
            {
                "description": "Mic(Bluetooth 4.2, Rockerz 450R...",
                "id": 3,
                "name": "Boat On-Ear Wireless",
                "price": 81.99,
                "qty": 45
            },
            {
                "description": "(MX30- waterproof) watch",
                "id": 4,
                "name": "Fitbit MX30 Smart Watch",
                "price": 85,
                "qty": 70
            }
        ],
        "invoice_id": 8795646525451,
        "notes": "",
        "quantity": 1000,
        "status": "Paid",
        "tax": 0.2
    },
    {
        "avatar": 4,
        "cashierInfo": {
            "address": "1300 Mine RoadQuemado, NM 87829",
            "email": "belljrc23@gmail.com",
            "name": "Belle J. Richter",
            "phone": "305-829-7809"
        },
        "customerInfo": {
            "address": "1754 Ureate, RhodSA5 5BO",
            "email": "iacrpt65@gmail.com",
            "name": "Ian Carpenter",
            "phone": "+91 1234567890"
        },
        "customer_name": "Abey Boseley",
        "date": "7/15/2022",
        "discount": 0,
        "due_date": "2/15/2022",
        "email": "aabsl32@gmail.com",
        "id": 2,
        "invoice_detail": [
            {
                "description": "7655 Couple (Refurbished)...",
                "id": 6,
                "name": "Luxury Watches Centrix Gold",
                "price": 29.99,
                "qty": 3
            },
            {
                "description": "SLR Camera (Black) with EF S18-55...",
                "id": 7,
                "name": "Canon EOS 1500D 24.1 Digital SLR",
                "price": 12.99,
                "qty": 50
            }
        ],
        "invoice_id": 8795646525452,
        "notes": "",
        "quantity": 2030,
        "status": "Unpaid",
        "tax": 0.8
    },
    {
        "avatar": 7,
        "cashierInfo": {
            "address": "3488 Arbutus DriveMiami, FL",
            "email": "rtyhn65@gmail.com",
            "name": "Ritika Yohannan",
            "phone": "+91 1234567890"
        },
        "customerInfo": {
            "address": "4388 House DriveWestville, OH +91",
            "email": "thomshj56@gmail.com",
            "name": "Thomas D. Johnson",
            "phone": "1234567890"
        },
        "customer_name": "Shelba Thews",
        "date": "7/6/2022",
        "discount": 1,
        "due_date": "7/8/2022",
        "email": "slbt37@gmail.com",
        "id": 3,
        "invoice_detail": [
            {
                "description": "13 cm (5.4-inch) Super",
                "id": 9,
                "name": "Apple iPhone 13 Mini ",
                "price": 86.99,
                "qty": 40
            },
            {
                "description": "11th Generation Intel\u00ae Core\u2122 i5-11320H ...",
                "id": 10,
                "name": "Apple MacBook Pro with Iphone",
                "price": 14.59,
                "qty": 70
            },
            {
                "description": "(512GB ROM, MLLH3HN/A,..",
                "id": 11,
                "name": "Apple iPhone 13 Pro",
                "price": 100,
                "qty": 21
            },
            {
                "description": "(512GB ROM, MLLH3HN/A,..",
                "id": 12,
                "name": "Canon EOS 1500D 24.1 Digital",
                "price": 399,
                "qty": 21
            }
        ],
        "invoice_id": 8795646525453,
        "notes": "",
        "quantity": 3000,
        "status": "Cancelled",
        "tax": 2
    },
    {
        "avatar": 8,
        "cashierInfo": {
            "address": "3488 Arbutus DriveMiami, FL 33012",
            "email": "jessghs78@gmail.com",
            "name": "Jesse G. Hassen",
            "phone": "+91 1234567890"
        },
        "customerInfo": {
            "address": "4388 House DriveWesrville, OH",
            "email": "crpthl643@gmail.com",
            "name": "Christopher P. Iacovelli",
            "phone": "+91 1234567890"
        },
        "customer_name": "Salvatore Boncore",
        "date": "2/8/2022",
        "discount": 0.89,
        "due_date": "3/30/2022",
        "email": "sabf231@gmail.com",
        "id": 4,
        "invoice_detail": [
            {
                "description": "7655 Couple (Refurbished)...",
                "id": 14,
                "name": "Luxury Watches Centrix Gold",
                "price": 29.99,
                "qty": 3
            },
            {
                "description": "SLR Camera (Black) with EF S18-55...",
                "id": 15,
                "name": "Canon EOS 1500D 24.1 Digital SLR",
                "price": 12.99,
                "qty": 50
            },
            {
                "description": "(512GB ROM, MLLH3HN/A,..",
                "id": 16,
                "name": "Apple iPhone 13 Pro",
                "price": 100,
                "qty": 21
            },
            {
                "description": "(512GB ROM, MLLH3HN/A,..",
                "id": 17,
                "name": "Canon EOS 1500D 24.1 Digital",
                "price": 399,
                "qty": 21
            }
        ],
        "invoice_id": 8795646525454,
        "notes": "",
        "quantity": 2000,
        "status": "Unpaid",
        "tax": 5.2
    },
    {
        "avatar": 2,
        "cashierInfo": {
            "address": "4388 House DriveWestville, OH +91",
            "email": "thomshj56@gmail.com",
            "name": "Thomas D. Johnson",
            "phone": "1234567890"
        },
        "customerInfo": {
            "address": "1754 Ureate, RhodSA5 5BO",
            "email": "iacrpt65@gmail.com",
            "name": "Ian Carpenter",
            "phone": "+91 1234567890"
        },
        "customer_name": "Mickie Melmoth",
        "date": "5/5/2022",
        "discount": 0.1,
        "due_date": "7/11/2022",
        "email": "mmsht23@gmail.com",
        "id": 5,
        "invoice_detail": [
            {
                "description": "7655 Couple (Refurbished)...",
                "id": 19,
                "name": "Luxury Watches Centrix Gold",
                "price": 29.99,
                "qty": 3
            },
            {
                "description": "SLR Camera (Black) with EF S18-55...",
                "id": 20,
                "name": "Canon EOS 1500D 24.1 Digital SLR",
                "price": 12.99,
                "qty": 50
            },
            {
                "description": "7655 Couple (Refurbished)...",
                "id": 21,
                "name": "Luxury Watches sliver",
                "price": 29.99,
                "qty": 3
            },
            {
                "description": "SLR Camera (Black) with EF S18-55...",
                "id": 22,
                "name": "Canon EOS 1800D",
                "price": 12.99,
                "qty": 50
            },
            {
                "description": "Apple Watch SE Smartwatch",
                "id": 23,
                "name": "Apple watch 5 series",
                "price": 275,
                "qty": 3
            }
        ],
        "invoice_id": 8795646525455,
        "notes": "",
        "quantity": 3000,
        "status": "Paid",
        "tax": 0.52
    }
]

export const KANBAN = {
    "backlogs": {
        "columns": [
            {
                "id": "column-1",
                "itemIds": [
                    "3542",
                    "8903",
                    "1381"
                ],
                "title": "New"
            },
            {
                "id": "column-2",
                "itemIds": [
                    "6739",
                    "3950",
                    "6924"
                ],
                "title": "Active"
            },
            {
                "id": "column-3",
                "itemIds": [
                    "4398"
                ],
                "title": "Resolved"
            },
            {
                "id": "column-4",
                "itemIds": [
                    "9589",
                    "3410",
                    "8679"
                ],
                "title": "Closed"
            }
        ],
        "columnsOrder": [
            "column-1",
            "column-2",
            "column-3",
            "column-4"
        ],
        "comments": [
            {
                "comment": "Comment 1",
                "id": "comment-1",
                "profileId": "profile-1"
            },
            {
                "comment": "Comment 2",
                "id": "comment-2",
                "profileId": "profile-2"
            },
            {
                "comment": "Comment 3",
                "id": "comment-3",
                "profileId": "profile-3"
            },
            {
                "comment": "Comment 4",
                "id": "comment-4",
                "profileId": "profile-2"
            },
            {
                "comment": "Comment 5",
                "id": "comment-5",
                "profileId": "profile-3"
            }
        ],
        "items": [
            {
                "assign": "profile-1",
                "attachments": [],
                "commentIds": [
                    "comment-1"
                ],
                "description": "Content of item 1",
                "dueDate": "Fri Feb 03 2023 15:20:14 GMT+0530 (India Standard Time)",
                "id": "3542",
                "image": "profile-back-1.png",
                "priority": "low",
                "title": "Online fees payment & instant announcements"
            },
            {
                "assign": "profile-2",
                "attachments": [],
                "commentIds": [
                    "comment-2",
                    "comment-5"
                ],
                "description": "Content of item 2",
                "dueDate": "Sat Jan 28 2023 15:23:25 GMT+0530 (India Standard Time)",
                "id": "4398",
                "image": false,
                "priority": "high",
                "title": "Creation and Maintenance of Inventory Objects"
            },
            {
                "assign": "profile-3",
                "attachments": [],
                "description": "Content of item 3",
                "dueDate": "Tue Feb 07 2023 15:24:38 GMT+0530 (India Standard Time)",
                "id": "6739",
                "image": false,
                "priority": "low",
                "title": "Update React & TypeScript version"
            },
            {
                "assign": "profile-2",
                "attachments": [],
                "commentIds": [
                    "comment-4"
                ],
                "description": "Content of item 4",
                "dueDate": "Thu Feb 09 2023 15:25:46 GMT+0530 (India Standard Time)",
                "id": "3950",
                "image": "profile-back-2.png",
                "priority": "low",
                "title": "Set allowing rules for trusted applications."
            },
            {
                "assign": "profile-2",
                "attachments": [],
                "commentIds": [
                    "comment-1",
                    "comment-2",
                    "comment-5"
                ],
                "description": "Content of item 5",
                "dueDate": "Mon Feb 06 2023 15:26:53 GMT+0530 (India Standard Time)",
                "id": "6924",
                "image": "profile-back-3.png",
                "priority": "medium",
                "title": "Managing Applications Launch Control"
            },
            {
                "assign": "profile-3",
                "attachments": [],
                "commentIds": [
                    "comment-3",
                    "comment-4"
                ],
                "description": "Content of item 6",
                "dueDate": "Wed Feb 15 2023 10:30:37 GMT+0530 (India Standard Time)",
                "id": "9589",
                "image": false,
                "priority": "medium",
                "title": "Run codemods"
            },
            {
                "assign": "profile-1",
                "attachments": [],
                "description": "Content of item 7",
                "dueDate": "Mon Feb 20 2023 15:29:58 GMT+0530 (India Standard Time)",
                "id": "3410",
                "image": "profile-back-4.png",
                "priority": "low",
                "title": "Purchase Requisitions, Adjustments, and Transfers."
            },
            {
                "assign": "profile-1",
                "attachments": [],
                "description": "Content of item 8",
                "dueDate": "Sat Mar 04 2023 15:31:05 GMT+0530 (India Standard Time)",
                "id": "8903",
                "image": false,
                "priority": "low",
                "title": "Attendance checking & homework details"
            },
            {
                "assign": "profile-3",
                "attachments": [],
                "commentIds": [
                    "comment-3"
                ],
                "description": "Content of item 9",
                "dueDate": "Thu Feb 23 2023 15:32:13 GMT+0530 (India Standard Time)",
                "id": "1381",
                "image": false,
                "priority": "high",
                "title": "Admission, Staff & Schedule management"
            },
            {
                "assign": "profile-2",
                "attachments": [],
                "commentIds": [
                    "comment-5"
                ],
                "description": "Content of item 10",
                "dueDate": "Mon Feb 27 2023 15:33:04 GMT+0530 (India Standard Time)",
                "id": "8679",
                "image": false,
                "priority": "low",
                "title": "Handling breaking changes"
            }
        ],
        "profiles": [
            {
                "avatar": "avatar-3.png",
                "id": "profile-1",
                "name": "Barney Thea",
                "time": "2 min ago"
            },
            {
                "avatar": "avatar-1.png",
                "id": "profile-2",
                "name": "Maddison Wilber",
                "time": "1 day ago"
            },
            {
                "avatar": "avatar-2.png",
                "id": "profile-3",
                "name": "John Doe",
                "time": "now"
            }
        ],
        "userStory": [
            {
                "acceptance": "",
                "assign": "profile-2",
                "columnId": "column-4",
                "commentIds": [
                    "comment-5"
                ],
                "description": "Wo gegew jubva wiej pisniidi ic jarge mide ho ufcakub culuw ambupan te fezop rikic ekbet sevzog.",
                "dueDate": "Mon Feb 27 2023 15:18:32 GMT+0530 (India Standard Time)",
                "id": "2647",
                "itemIds": [
                    "3542",
                    "8903",
                    "1381"
                ],
                "priority": "low",
                "title": "School Management Backend"
            },
            {
                "acceptance": "Gid gimija ufuebjop vuji ze ir wi jih aruvihdok keubagob aguhogug uge tabu cure.",
                "assign": "profile-3",
                "columnId": "column-1",
                "commentIds": [
                    "comment-3"
                ],
                "description": "Onekane urwa joduzzij la cipebo zafuw atawa labfi hilza inepehhow inujufise hum.",
                "dueDate": "Thu Feb 23 2023 15:13:31 GMT+0530 (India Standard Time)",
                "id": "7833",
                "itemIds": [
                    "4398",
                    "3410"
                ],
                "priority": "high",
                "title": "Inventory Implementation & Design"
            },
            {
                "acceptance": "Kiz ovmen fup jazaj rozibco fecki rasizsed pake redufkav joczatufo.",
                "assign": "profile-3",
                "columnId": "column-4",
                "commentIds": [
                    "comment-3",
                    "comment-4"
                ],
                "description": "Lum vofdip keci fid fos di fikga kiinte izugfi gihude tewsadez ha niprizbef catin adahup.",
                "dueDate": "Wed Feb 15 2023 10:30:11 GMT+0530 (India Standard Time)",
                "id": "6940",
                "itemIds": [
                    "6739",
                    "9589",
                    "8679"
                ],
                "priority": "medium",
                "title": "Theme migration from v4 to v5"
            },
            {
                "acceptance": "Itorinceg cokmu ku pahkaavo argut.",
                "assign": "profile-1",
                "columnId": "column-3",
                "commentIds": [
                    "comment-4"
                ],
                "description": "Nar noljaw hi fusurri haodabi ewaw uc moetucu hilzirzo ca nidzerog ziw.",
                "dueDate": "Tue Feb 07 2023 15:17:40 GMT+0530 (India Standard Time)",
                "id": "4656",
                "itemIds": [
                    "3950",
                    "6924"
                ],
                "priority": "low",
                "title": "Lunch Beauty Application"
            }
        ],
        "userStoryOrder": [
            "2647",
            "7833",
            "6940",
            "4656"
        ]
    }
}


export const LOGGED_IN_USER = {
    "id": "5e87809273e28b96d2e38538",
    "email": "info@phoenixcoded.co",
    "name": "JWT User",
    "role": "Admin"
}